import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";

const translations = {
  es: {
    dir: "ltr",
    // App
    app_name: "MEOS CARGO",
    app_tagline: "Plataforma profesional de envíos",
    // Login
    login_title: "Iniciar sesión",
    user_or_email: "Usuario o Email",
    password: "Contraseña",
    enter: "Entrar",
    demo_users: "Usuarios demo:",
    login_error: "Usuario o contraseña incorrectos",
    logout: "Cerrar sesión",
    // Nav
    dashboard: "Dashboard",
    quote_shipping: "Cotizar Envío",
    clients: "Clientes",
    shipments: "Envíos",
    own_routes: "Rutas Propias",
    prices_margins: "Precios & Márgenes",
    select_office: "Elige la oficina",
    main_office: "Oficina principal del país",
    exp_office_hint: "El gasto sólo aparece en la contabilidad de la oficina que elijas.",
    orphans_title: "Hay registros contables sin oficina asignada",
    orphans_hint: "Ninguna sucursal los ve. Asigna una oficina para que aparezcan en su contabilidad.",
    orphans_adopt: "Adoptar en esa oficina",
    attach_receipt: "Adjuntar factura / recibo",
    download_pdf: "Descargar PDF",
    expense_voucher: "Comprobante de gasto",
    payment_voucher: "Comprobante de cobro",
    provider_ranking: "Ranking de gastos por proveedor",
    us_owe: "Nos deben",
    we_owe: "Debemos",
    last: "último",
    total_payable: "Total por pagar",
    overdue: "Vencido",
    upcoming_dues: "Próximos vencimientos",
    overdue_bills: "Facturas vencidas",
    upcoming_bills: "Próximos a vencer",
    attachment: "Adjunto",
    attach_bill: "Adjuntar factura / imagen",
    account_code: "Código de cuenta",
    search_users: "Buscar por nombre, código de cuenta o ID",
    main: "Principal",
    venc_vencida: "Vencida",
    venc_proxima: "Próxima",
    venc_vigente: "Vigente",
    venc_sin_vencimiento: "Sin vencimiento",
    inbound_master_actions: "Este envío viene hacia tu oficina",
    inbound_masters: "Envíos entrantes",
    inbound_packages_hint: "paquetes hacia tu oficina",
    client_special_pricing: "Precios especiales",
    client_special_pricing_hint: "Estos precios se aplican automáticamente cuando el cliente cotiza o cuando alguien cotiza en su nombre.",
    volumetric_rules: "Reglas Volumétricas",
    users: "Usuarios",
    api: "API",
    language: "Idioma",
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    new: "Nuevo",
    delete: "Eliminar",
    edit: "Editar",
    active: "Activa",
    inactive: "Inactiva",
    actions: "Acciones",
    status: "Estado",
    name: "Nombre",
    email: "Email",
    username: "Usuario",
    role: "Rol",
    // Roles
    admin: "Administrador",
    ventas: "Ventas",
    operaciones: "Operaciones",
    cliente: "Cliente",
    // Dashboard
    welcome: "Bienvenido",
    quick_access: "Accesos rápidos",
    total_users: "Usuarios",
    active_routes: "Rutas activas",
    air_divisor: "Divisor Aéreo",
    sea_divisor: "Divisor Marítimo",
    // Quote
    quote_type: "Tipo de transporte",
    aereo: "Aéreo",
    terrestre: "Terrestre",
    maritimo: "Marítimo",
    origin_country: "País Origen",
    destination_country: "País Destino",
    select_option: "Seleccionar...",
    china_city_origin: "Ciudad de origen en China",
    china_notice: "Para Siria, Irak y Líbano solo se permite desde Guangzhou o Yiwu",
    postal_origin: "CP Origen (Europa)",
    postal_dest: "CP Destino (Europa)",
    cargo_type: "Tipo de carga",
    cargo_kg: "Kilogramos (KG)",
    cargo_cbm: "CBM (metros cúbicos)",
    cargo_pallets: "Pallets",
    length: "Largo (cm)",
    width: "Ancho (cm)",
    height: "Alto (cm)",
    weight_kg: "Peso (kg)",
    cbm_amount: "Cantidad de CBM",
    total_weight: "Peso total (kg)",
    pallets_qty: "Cantidad de Pallets",
    hs_code: "HS Code (opcional)",
    calculate: "Calcular precios",
    select_route: "Seleccionar",
    empty_quote: "Selecciona origen, destino y tipo de transporte",
    empty_quote_sub: "Soporta Aéreo, Terrestre y Marítimo a todo el mundo",
    meos_route: "★ Ruta Meos",
    estimated_rates: "Tarifas estimadas",
    // Routes
    origin: "Origen",
    destination: "Destino",
    price_base: "Precio base",
    price_kg: "Precio por KG",
    price_cbm: "Precio por CBM",
    price_pallet: "Precio por Pallet",
    transit_days: "Días de tránsito",
    service_name: "Nombre del servicio",
    mode: "Modo",
    all_modes: "Todos los modos",
    new_route: "Nueva Ruta",
    edit_route: "Editar Ruta",
    routes_note: "Las rutas propias tienen prioridad sobre APIs externas",
    // Users
    fullname: "Nombre completo",
    new_user: "Nuevo Usuario",
    user_created: "Usuario creado",
    user_exists: "Usuario o email ya existe",
    // Config
    general_margin: "Margen general (%)",
    guide_charge: "Cargo por guía ($)",
    air_divisor_full: "Divisor Aéreo (estándar IATA = 6000)",
    sea_divisor_full: "Divisor Marítimo (estándar = 1000)",
    formula_air: "Fórmula: (Largo × Ancho × Alto) / divisor = kg volumétricos",
    formula_sea: "Se usa para convertir CBM a peso estimado",
    // Toasts
    saved: "Guardado correctamente",
    deleted: "Eliminado",
    confirm_delete: "¿Confirmas eliminar?",
    no_clients: "Sin clientes registrados",
    shipments_soon: "Módulo de envíos (próximamente)",
    // Shipments
    tracking_code: "Código de envío",
    assign_client: "Cliente asignado",
    description: "Descripción / mercancía",
    estimated_date: "Fecha estimada",
    internal_notes: "Notas internas",
    new_shipment: "Nuevo envío",
    my_shipments: "Mis envíos",
    my_registered_packages: "Mis paquetes registrados",
    incoming_shipment: "Entrante",
    backdate_label: "Fecha antigua (admin)",
    backdate_hint: "Solo admin — registra el paquete con una fecha pasada",
    track: "Rastrear",
    flow_clasificado: "Clasificado",
    flow_en_salida: "En salida",
    flow_transito_hub: "Tránsito a hub",
    flow_recibido_hub: "Recibido en hub",
    flow_verificado_hub: "Verificado",
    flow_en_master: "En master",
    flow_master_cerrado: "Master cerrado",
    flow_entregado: "Entregado",
    merch_charge_type: "Tipo de cargo",
    merch_per_shipment: "Por envío",
    merch_per_kg: "Por kilo",
    sales_crm: "Ventas · CRM",
    crm_quotes: "Cotizaciones",
    crm_followups: "Seguimientos",
    crm_new_lead: "Nuevo cliente",
    crm_no_leads: "Todavía no hay clientes registrados",
    crm_no_history: "Aún no hay historial. Registra la primera llamada",
    crm_log_call: "Registrar llamada",
    crm_new_quote: "Cotización",
    crm_add_task: "Seguimiento",
    crm_timeline: "Historial 360°",
    crm_no_results: "Sin resultados",
    crm_leads_search_ph: "Buscar por nombre, teléfono, email...",
    crm_call_when: "Cuándo",
    crm_call_reason: "Motivo",
    crm_caller: "Quién llamó",
    crm_request: "Qué necesita",
    crm_call_notes: "Información importante",
    crm_next_step: "Próximo seguimiento",
    crm_action: "Acción",
    crm_when: "Cuándo",
    crm_service: "Servicio",
    crm_terms: "Condiciones",
    crm_valid_until: "Vence",
    crm_task_type: "Tipo",
    crm_task_detail: "Detalle",
    crm_source: "Origen",
    crm_company: "Empresa / cliente",
    crm_contact_person: "Persona contacto",
    crm_notes: "Observaciones",
    crm_new_leads: "Nuevos clientes (7d)",
    crm_calls_today: "Llamadas hoy",
    crm_quotes_pending: "Cot. pendientes",
    crm_tasks_today: "Seguim. hoy",
    crm_tasks_overdue: "Atrasados",
    crm_tasks_upcoming: "Próximos 7d",
    crm_quotes_won: "Aceptadas",
    crm_quotes_lost: "Perdidas",
    crm_no_tasks_today: "No hay seguimientos para hoy",
    crm_no_overdue: "Sin atrasos. Buen trabajo",
    crm_no_tasks: "Sin tareas en este bucket",
    crm_no_quotes: "Sin cotizaciones",
    crm_seed_confirm: "¿Cargar 3 clientes de ejemplo del CRM?",
    crm_seed_hint_title: "Aún no hay datos",
    crm_seed_hint_desc: "Carga 3 clientes de ejemplo con llamadas y cotizaciones para explorar el CRM",
    crm_seed_btn: "Cargar ejemplos",
    crm_stats: "Estadísticas",
    crm_route_data: "Ruta solicitada",
    crm_stats_total: "Consultas",
    crm_stats_by_route: "Consultas por ruta",
    crm_stats_empty: "No hay cotizaciones con datos de ruta en el rango seleccionado",
    destination_city: "Ciudad destino",
    transport: "Modo",
    from: "Desde",
    to: "Hasta",
    crm_mark_done: "Marcar hecha",
    crm_state_nueva: "Nueva",
    crm_state_cotizada: "Cotizada",
    crm_state_pendiente: "Pendiente",
    crm_state_seguimiento: "Seguimiento",
    crm_state_aceptada: "Aceptada",
    crm_state_confirmada: "Confirmada",
    crm_state_rechazada: "Rechazada",
    crm_state_perdida: "Perdida",
    crm_state_cancelada: "Cancelada",
    crm_type_llamar: "Llamar",
    crm_type_enviar_precio: "Enviar precio",
    crm_type_enviar_docs: "Enviar docs",
    crm_type_esperar_confirmacion: "Esperar confirmación",
    crm_type_confirmar_envio: "Confirmar envío",
    crm_type_recontactar: "Recontactar",
    crm_type_otro: "Otro",
    crm_reason_cotizacion: "Cotización",
    crm_reason_seguimiento: "Seguimiento",
    crm_reason_complaint: "Reclamación",
    crm_reason_reclamacion: "Reclamación",
    crm_reason_informacion: "Información",
    crm_reason_info: "Información",
    crm_reason_quote: "Cotización",
    crm_reason_followup: "Seguimiento",
    crm_origin_call: "Llamada",
    crm_origin_web: "Web",
    crm_origin_referral: "Referido",
    crm_origin_trade_show: "Feria",
    crm_origin_other: "Otro",
    crm_new_request: "Añadir Nueva Solicitud",
    crm_request_contact: "Datos de contacto",
    crm_request_route: "Ruta del envío",
    crm_request_cargo: "Datos de la carga",
    crm_contact_name: "Nombre del cliente",
    crm_from_country: "País de origen",
    crm_to_country: "País de destino",
    crm_shipping_mode: "Forma de envío",
    trace_label_created: "Etiqueta creada",
    trace_received_warehouse: "Recibido en almacén",
    trace_grupaje_recibido_oficina: "Recibido en oficina",
    trace_grupaje_etiquetado: "Etiquetado",
    trace_grupaje_clasificado: "Clasificado",
    trace_grupaje_actualizado: "Datos actualizados",
    trace_grupaje_anadido_salida: "Añadido a salida de oficina",
    trace_grupaje_retirado_salida: "Retirado de la salida",
    trace_grupaje_salida_oficina: "Salida de oficina · en tránsito al hub",
    trace_grupaje_recibido_hub: "Recibido en el HUB",
    trace_grupaje_verificado_hub: "Verificado OK en el HUB",
    trace_grupaje_faltante: "Faltante en recepción",
    trace_grupaje_anadido_master: "Añadido al MASTER",
    trace_grupaje_retirado_master: "Retirado del MASTER",
    trace_grupaje_master_cerrado: "MASTER cerrado",
    trace_grupaje_en_transito: "En tránsito al destino",
    trace_grupaje_recibido_destino: "Recibido en destino",
    trace_grupaje_entregado: "Entregado",
    trace_inv_received: "Recibido en inventario",
    trace_inv_packaged: "Empaquetado",
    trace_inv_dispatched: "Despachado",
    trace_picked_by_driver: "Recogido por conductor",
    trace_in_dispatch_manifest: "En manifiesto de salida",
    trace_ship_status_recibido: "Estado: Recibido",
    trace_ship_status_despacho: "Estado: Despachado",
    trace_ship_status_en_aduana: "Estado: En aduana",
    trace_ship_status_en_reparto: "Estado: En reparto",
    trace_ship_status_entregado: "Estado: Entregado",
    trace_audit_create_shipment: "Envío creado",
    trace_audit_update_shipment: "Envío actualizado",
    trace_audit_delete_shipment: "Envío eliminado",
    trace_audit_create_label: "Etiqueta creada",
    trace_audit_update_label: "Etiqueta actualizada",
    trace_audit_delete_label: "Etiqueta eliminada",
    trace_audit_receive: "Recepción registrada",
    trace_audit_dispatch: "Despacho registrado",
    trace_audit_assign_master: "Asignado a master",
    trace_audit_unassign_master: "Retirado de master",
    trace_audit_create_manifest: "Manifiesto creado",
    trace_audit_close_manifest: "Manifiesto cerrado",
    trace_audit_scan: "Escaneo registrado",
    trace_audit_status_change: "Cambio de estado",
    trace_audit_invoice: "Factura emitida",
    trace_audit_payment: "Pago registrado",
    trace_audit_incident: "Incidencia registrada",
    state_received_office: "Recibido en oficina",
    state_labeled: "Etiquetado",
    state_added_master: "Añadido al MASTER",
    state_added_office_exit: "Añadido a salida",
    state_in_transit: "En tránsito al destino",
    state_received_destination: "Recibido en destino",
    all_shipments: "Todos los envíos",
    status_recibido: "Recibido",
    status_despacho: "Despacho",
    status_en_aduana: "En aduana",
    status_en_reparto: "En reparto",
    status_entregado: "Entregado",
    update_status: "Actualizar estado",
    status_history: "Historial de estados",
    shipment_created: "Envío creado",
    no_shipments: "Aún no tienes envíos",
    no_shipments_admin: "No hay envíos registrados",
    tracking_placeholder: "MEOS-2026-000123",
    client: "Cliente",
    // Quote extras
    no_route_available: "No hay ruta configurada por el administrador para este origen/destino",
    price_breakdown: "Desglose de precio",
    subtotal: "Subtotal",
    margin: "Margen",
    guide_fee: "Cargo por guía",
    total: "Total",
    view_details: "Ver detalles",
    base_prices_tiers: "Precios base y escalones",
    port_origin: "Puerto/Aeropuerto de origen",
    port_dest: "Puerto/Aeropuerto de destino",
    observations: "Observaciones",
    fcl: "Contenedor completo (FCL)",
    container_type: "Tipo de contenedor",
    container_20: "20 pies",
    container_40: "40 pies",
    container_40hc: "40 HC",
    container_weight: "Peso del contenedor (kg)",
    cargo_weight: "Peso de la mercancía (kg)",
    total_weight_fcl: "Peso total",
    price_20ft: "Precio 20ft",
    price_40ft: "Precio 40ft",
    price_40hc: "Precio 40HC",
    public_tracking: "Rastreo público",
    track_placeholder: "Ingresa tu código de envío",
    track: "Rastrear",
    notifications: "Notificaciones",
    no_notifications: "No hay notificaciones",
    mark_all_read: "Marcar todo como leído",
    currency: "Moneda",
    sucursal: "Sucursal",
    office: "Oficina / Sucursal",
    assigned_office: "Oficina asignada",
    google_signin: "Continuar con Google",
    or: "o",
    services_enabled: "Servicios habilitados en esta ruta",
    services_hint: "Marca únicamente los tipos de cálculo que aplican para esta ruta. Los desmarcados no aparecerán al cotizar.",
    price_kg_short: "KG",
    pending: "Pendientes",
    delivered_this_month: "Entregados este mes",
    recent_shipments: "Envíos recientes",
    notif_shipment_created_title: "Nuevo envío {code}",
    notif_shipment_created_msg: "Se ha creado tu envío {origen} → {destino}",
    notif_status_change_title: "Actualización {code}",
    notif_status_change_msg: "Tu envío ahora está: {status}",
    history: "Historial",
    quotes: "Cotizaciones",
    no_history: "Aún no hay cotizaciones",
    search: "Buscar...",
    province: "Provincia / Estado",
    sucursal_price: "Precio Sucursal",
    sucursal_prices_hint: "Precio especial que se aplica solo a usuarios sucursal o clientes que ingresen esta provincia.",
    ship_label: "Guía de envío",
    print_label: "Imprimir guía",
    // CRM - Clientes extendido
    client_type: "Tipo de cliente",
    private: "Privado",
    company: "Empresa",
    address: "Dirección",
    city: "Ciudad",
    country: "País",
    postal_code: "Código postal",
    phone: "Teléfono",
    phone_alt: "Teléfono alternativo",
    rfc_nit: "RFC / NIT / CIF",
    doc_id: "Documento de identidad",
    sector: "Sector / Industria",
    contact_person: "Persona de contacto",
    notes: "Notas",
    assigned_branch: "Sucursal asignada",
    auto_by_province: "Automático según provincia",
    edit_client: "Editar cliente",
    new_client: "Nuevo cliente",
    search_clients: "Buscar por nombre, email, empresa o teléfono...",
    reset_password: "Resetear contraseña",
    reset_password_manual: "Generar contraseña manual",
    reset_password_email: "Enviar contraseña temporal por email",
    new_password: "Nueva contraseña",
    password_reset_success: "Contraseña actualizada",
    password_sent_email: "Contraseña enviada por email a",
    generated_password: "Contraseña generada",
    copy: "Copiar",
    copied: "Copiado",
    close: "Cerrar",
    personal_info: "Datos personales",
    company_info: "Datos de empresa",
    contact_info: "Contacto",
    address_info: "Dirección",
    complete_profile: "Completa tu perfil",
    complete_profile_desc: "Necesitamos algunos datos para asignarte a la sucursal correcta y agilizar tus envíos.",
    skip_for_now: "Omitir por ahora",
    save_profile: "Guardar perfil",
    profile_updated: "Perfil actualizado",
    provincias_covered: "Provincias cubiertas por esta sucursal",
    provincias_hint: "Ingresa las provincias separadas por coma. Cuando un cliente indique una de estas provincias, se le asignará esta sucursal automáticamente.",
    registered_by: "Registrado por",
    self_registered: "Registro propio",
    show_password: "Mostrar",
    hide_password: "Ocultar",
    optional: "opcional",
    // Shipment address fields
    sender: "Remitente",
    receiver: "Destinatario",
    street: "Calle",
    number: "Número",
    tax_id: "Tax ID / NIF",
    address_reference: "Referencia de dirección",
    alias: "Alias",
    save_address: "Guardar dirección",
    address_book: "Direcciones guardadas",
    load_from_book: "Cargar de mis direcciones",
    minimize: "Minimizar",
    expand: "Expandir",
    // Warehouses / Inventory / Schedules / Countries
    countries: "Países",
    new_country: "Nuevo país",
    warehouses: "Almacenes",
    warehouse: "Almacén",
    new_warehouse: "Nuevo almacén",
    no_warehouses: "Sin almacenes registrados",
    warehouse_required: "Selecciona un almacén",
    inventory: "Inventario",
    inbound: "Entrada",
    outbound: "Salida",
    scan: "Escanear",
    scan_barcode: "Escáner de código de barras",
    scan_hint: "Enfoca el lector o pega el código y pulsa Enter",
    scan_found: "Encontrado",
    not_found: "No encontrado",
    location: "Ubicación",
    units: "Unidades",
    state: "Estado",
    state_received: "Recibido",
    state_packaged: "Empaquetado",
    state_dispatched: "Despachado",
    no_inventory: "Sin items en inventario",
    schedules: "Programación",
    admin_editable: "Solo admin puede editar",
    read_only: "Solo lectura",
    container: "Contenedor",
    route: "Ruta",
    estimated_departure: "Salida prevista",
    confirmed_departure: "Salida confirmada",
    estimated_arrival: "Llegada estimada",
    // Approvals
    pending_approvals: "Aprobaciones pendientes",
    approve: "Aprobar",
    reject: "Rechazar",
    account_pending: "Tu cuenta está pendiente de aprobación",
    account_pending_desc: "Un administrador revisará tu registro pronto. Te avisaremos por correo cuando esté listo.",
    // Route sucursal pricing
    branch_pricing: "Precios por sucursal",
    add_branch_price: "Añadir precio de sucursal",
    select_branch: "Selecciona sucursal",
    // Almacen role
    role_almacen: "Almacén",
    // ShipmentIn extra
    container_number: "Nº de contenedor",
    // Voyages, manifests, labels
    voyages: "Salidas / Viajes",
    voyage: "Viaje",
    new_voyage: "Nueva salida",
    no_voyages: "Sin salidas registradas",
    port_from: "Puerto origen",
    port_to: "Puerto destino",
    vessel: "Vessel / Nº de barco",
    cut_off: "Cut-off",
    departure: "Salida",
    arrival: "Llegada",
    custom_fields: "Campos personalizados",
    field_name: "Nombre del campo",
    value: "Valor",
    add: "Añadir",
    air: "Aéreo",
    sea: "Marítimo",
    ground: "Terrestre",
    vehicle: "Vehículo",
    driver: "Conductor",
    // Manifests
    new_manifest: "Nuevo manifiesto",
    no_manifests: "Sin manifiestos",
    manifest_sucursal_out: "Salida sucursal",
    manifest_hub_in: "Entrada hub",
    manifest_hub_out: "Salida hub",
    receive: "Recibir",
    received: "Recibido",
    receive_manifest: "Recibir manifiesto",
    scan_manifest_barcode: "Escanear código del manifiesto",
    mark_missing: "Marcar paquete faltante",
    missing: "Faltante(s)",
    all_received_hint: "Si no marcas nada, se recibirán todos los paquetes",
    confirm_receipt: "Confirmar recepción",
    note_optional: "Nota (opcional)",
    select: "Selecciona",
    assign_shipments: "Asignar envíos",
    // Labels
    labels: "Etiquetas",
    new_label: "Nueva etiqueta",
    no_labels: "Aún no hay etiquetas",
    packages: "Paquetes",
    dimensions: "Dimensiones",
    reference: "Referencia",
    content: "Contenido",
    save_and_print: "Crear + Imprimir",
    print: "Imprimir",
    // Camera scan
    camera: "Cámara",
    camera_scan: "Escanear con cámara",
    stop: "Detener",
    manifests: "Manifiestos",
    // Scanner workflow (enterprise)
    scanner_mode: "Modo escáner",
    mode_receive_manifest: "Recepción con manifiesto",
    mode_receive_direct: "Recepción directa",
    mode_prepare_exit: "Preparar salida",
    mode_receive_manifest_desc: "Escanea el manifiesto y valida cada paquete",
    mode_receive_direct_desc: "Recibe paquetes sin manifiesto previo",
    mode_prepare_exit_desc: "Escanea paquetes y auto-genera manifiesto de salida",
    step_1_scan_manifest: "Paso 1 · Escanea el manifiesto",
    step_2_scan_packages: "Paso 2 · Escanea cada paquete",
    step_3_close_reception: "Paso 3 · Cerrar recepción",
    expected: "Esperados",
    scanned: "Escaneados",
    matches: "Coinciden",
    extras: "Extras",
    close_reception: "Cerrar recepción",
    open_reception: "Iniciar recepción",
    package_ok: "Paquete OK",
    package_extra: "Paquete extra (no esperado)",
    package_duplicate: "Ya escaneado",
    unknown_package: "Paquete desconocido",
    quick_create_shipment: "Crear envío rápido",
    generate_exit_manifest: "Generar manifiesto de salida",
    exit_destination: "Destino de salida",
    scanned_packages: "Paquetes escaneados",
    incidents: "Incidencias",
    incident_faltante: "Faltante",
    incident_extra: "Extra",
    incident_dano: "Daño",
    incident_retraso: "Retraso",
    severity: "Severidad",
    severity_low: "Baja",
    severity_medium: "Media",
    severity_high: "Alta",
    audit_trail: "Auditoría interna",
    public_tracking: "Rastreo público",
    reception_summary: "Resumen de recepción",
    of: "de",
    remove: "Quitar",
    reset: "Reiniciar",
    photo_url: "URL foto (opcional)",
    warehouse_id_required: "Se requiere almacén asignado",
    client_required_new_pkg: "Selecciona un cliente para crear el envío",
    incidents_created: "Incidencias creadas",
    view_audit: "Ver auditoría",
    action: "Acción",
    when: "Cuándo",
    who: "Quién",
    reception_started: "Recepción iniciada",
    reception_closed: "Recepción cerrada",
    // Albaranes / Locations / voyage detail extra keys
    package_receipt: "Albarán",
    new_delivery_note: "Nuevo albarán",
    no_delivery_notes: "Sin albaranes",
    incidence_optional: "Incidencia (opcional)",
    save_and_pdf: "Guardar + PDF",
    package_weight_kg: "Peso kg",
    packages_count: "Bultos",
    receiver_name: "Nombre receptor",
    address: "Dirección",
    country: "País",
    city: "Ciudad",
    pickup: "Recogida",
    delivery: "Entrega",
    receiver: "Receptor",
    shipment: "Envío",
    tracking: "Tracking",
    global_audit: "Auditoría global",
    zone_required: "Zona *",
    aisle_required: "Pasillo *",
    warehouse_required: "Almacén *",
    rack_short: "Estant.",
    level: "Nivel",
    position_short: "Posic.",
    cap_units: "Cap. bultos",
    new_location: "Nueva ubicación",
    no_locations_add_first: "Sin ubicaciones. Añade la primera.",
    all_warehouses: "Todos los almacenes",
    create: "Crear",
    auto_prefix: "Auto",
    signature_receiver: "Firma del receptor",
    clear: "Limpiar",
    courier: "Courier",
    courier_documentos: "Documentos",
    courier_pasaporte: "Pasaporte",
    courier_goods: "Mercancía",
    locations: "Ubicaciones WMS",
    zone: "Zona",
    type: "Tipo",
    date_col: "Fecha",
    route_col: "Ruta",
    mode_col: "Modo",
    cargo_col: "Carga",
    best_price_col: "Mejor precio",
    delivery_receipts: "Albaranes",
    // Merchandise types (admin-configurable per route)
    merchandise: "Mercancía",
    merchandise_types: "Tipos de mercancía",
    merchandise_types_hint: "Categorías definibles por ruta con recargo opcional y flag obligatorio",
    add_merchandise_type: "Añadir tipo",
    no_merchandise_types: "Sin tipos de mercancía",
    merch_name: "Nombre",
    merch_name_ph: "Electrónicos, Ropa, Frágil...",
    merch_surcharge: "Recargo",
    mandatory: "Obligatorio",
    merch_required_hint: "Selecciona el tipo de mercancía para continuar",
    // Assign to voyage (Envios)
    assign_to_voyage: "Asignar a Voyage",
    select_for_dispatch: "Seleccionar para despacho",
    select_shipments_hint: "Selecciona al menos un envío",
    selected_shipments: "Envíos seleccionados",
    manifest_will_be_generated: "Se generará un manifiesto de salida",
    no_voyage_optional: "Sin voyage (opcional)",
    manifest_name: "Nombre del manifiesto",
    manifest_copy: "Copia de manifiesto",
    assign_and_generate: "Asignar y generar",
    assigned: "Asignado",
    not_found: "No encontrados",
    dispatch: "Despacho",
    departure: "Salida",
    vehicle: "Vehículo",
    driver: "Conductor",
    container: "Contenedor",
    // Multi-box / master shipment
    boxes: "Cajas",
    bultos: "Bultos",
    bultos_short: "bultos",
    add_box: "Añadir caja",
    boxes_editor_hint: "Divide un envío en varias cajas con código y peso individuales",
    no_items_single_box: "Sin cajas: se creará como envío simple",
    print_all_labels: "Todas las etiquetas",
    // Report language
    report_language: "Idioma del reporte",
    // Roles
    role_contable: "Contable",
    contable: "Contable",
    all: "Todas",
    date: "Fecha",
    wms_locations: "Ubicaciones WMS",
    albaranes: "Albaranes",
    // Fleet / drivers
    fleet: "Flota y Conductores",
    drivers: "Conductores",
    vehicles: "Vehículos",
    driver_routes: "Rutas de reparto",
    new_driver: "Nuevo conductor",
    new_vehicle: "Nuevo vehículo",
    new_driver_route: "Nueva ruta de reparto",
    no_routes_yet: "Todavía no hay rutas de reparto",
    no_vehicle: "Sin vehículo",
    stops: "Paradas",
    plate: "Matrícula",
    brand: "Marca",
    model: "Modelo",
    capacity_kg: "Capacidad (kg)",
    capacity_m3: "Capacidad (m³)",
    insurance: "Seguro",
    license: "Licencia",
    license_expiry: "Caduca licencia",
    expiry_alert: "Caducidad",
    veh_furgoneta: "Furgoneta",
    veh_camion: "Camión",
    veh_trailer: "Tráiler",
    veh_coche: "Coche",
    route_state_pendiente: "Pendiente",
    route_state_en_curso: "En curso",
    route_state_completada: "Completada",
    stop_pendiente: "Pendiente",
    stop_en_camino: "En camino",
    stop_entregado: "Entregado",
    stop_fallido: "Fallido",
    stop_type_entrega: "Entrega",
    stop_type_recogida: "Recogida",
    conductor: "Conductor",
    role_conductor: "Conductor",
    link_user_account: "Cuenta de usuario (para la app del conductor)",
    edit_driver: "Editar conductor",
    edit_vehicle: "Editar vehículo",
    // Driver app
    my_route: "Mi ruta",
    no_route_today: "No tienes ruta asignada",
    mark_on_the_way: "Marcar en camino",
    mark_delivered: "Entregado + recibo",
    mark_picked_up: "Recogido + recibo",
    mark_failed: "Fallido",
    delivery_evidence: "Fotos de evidencia (DNI, mercancía)",
    print_receipt: "Recibo PDF",
    open_maps: "Mapa",
    call: "Llamar",
    whatsapp_notify: "Avisar por WhatsApp",
    optimize_route: "Optimizar ruta",
    optimizing: "Optimizando…",
    route_optimized: "Ruta optimizada por cercanía",
    total_distance: "Distancia total",
    est_arrival: "Llegada estimada",
    stops_no_location: "paradas sin ubicación",
    search_shipment: "Buscar por código, cliente, origen, destino…",
    no_search_results: "Sin resultados para tu búsqueda",
    whatsapp_auto: "WhatsApp automático",
    whatsapp_auto_hint: "Avisar al cliente por WhatsApp al cambiar el estado",
    transport_mode: "Transporte",
    road: "Terrestre",
    account_number: "Nº de cuenta",
    auto_account: "Automático",
    download_backup_pc: "Descargar backup a mi ordenador",
    email_backup_now: "Enviar backup por email ahora",
    backup_email_sent: "Backup enviado por email",
    pickup_scan: "Recogida por escaneo",
    pickup_scan_hint: "Escanea envíos, cajas o etiquetas y genera un manifiesto de recogida",
    scan_or_type_code: "Escanea o escribe el código…",
    generate_pickup_manifest: "Generar manifiesto de recogida",
    picked_up: "Recogido",
    scan_at_least_one: "Añade al menos un código",
    give_entry: "Dar entrada",
    already_received: "Esta etiqueta ya fue recibida",
    recipient: "Destinatario",
    label: "Etiqueta",
    trace: "Trazabilidad",
    trace_search: "Buscar por track, etiqueta o código de caja…",
    trace_timeline: "Historial interno del paquete",
    trace_no_result: "Sin resultados para ese código",
    pickups_tab: "Recogidas",
    pickups_today: "Recogidas de hoy",
    total_weight: "Peso total",
    notify_pickup_wa: "Avisar recogida por WhatsApp",
    bank: "Banco",
    concept: "Concepto",
    charges: "Cargos",
    credits: "Abonos",
    paid: "Pagado",
    remarks: "Observaciones",
    remarks_hint: "Si lo dejas vacío se usa el texto por defecto de la sucursal o de la empresa",
    edit_invoice: "Editar factura",
    // Accounting extra tabs
    acc_tab_aging: "Vencidas",
    acc_tab_suppliers: "Proveedores",
    acc_tab_branches: "Sucursales",
    acc_tab_statement: "Extractos",
    receivables: "Cobrar a clientes",
    payables: "Pagar a proveedores",
    outstanding_total: "Total pendiente",
    overdue_total: "Total vencido",
    days_overdue: "Días vencido",
    nothing_overdue: "No hay saldos pendientes",
    bucket_no_vencido: "Al día",
    bucket_d0_30: "1-30 días",
    bucket_d31_60: "31-60 días",
    bucket_d61_90: "61-90 días",
    bucket_d90_plus: "+90 días",
    bucket_sin_vencimiento: "Sin vencimiento",
    // Suppliers
    suppliers: "Proveedores",
    supplier: "Proveedor",
    new_supplier: "Nuevo proveedor",
    purchase_invoices: "Facturas de compra",
    purchase_invoice: "Factura de compra",
    new_bill: "Nueva factura de compra",
    bill_number: "Nº proveedor",
    new_bill_payment: "Registrar pago",
    owed_to_suppliers: "Debemos a proveedores",
    // Branch account
    owed_by_branches: "Las sucursales nos deben",
    branch_account: "Cuenta con las sucursales",
    ledger_entries: "Cargos y abonos",
    new_ledger_entry: "Nuevo cargo / abono",
    ledger_hint: "Cargo = la sucursal nos debe · Abono = la sucursal liquida",
    mov_cargo: "Cargo",
    mov_abono: "Abono",
    mov_factura: "Factura",
    mov_cobro: "Cobro",
    mov_gasto: "Gasto",
    mov_factura_compra: "Factura compra",
    mov_pago: "Pago",
    // Statements
    statement: "Extracto",
    statement_type: "Tipo de extracto",
    statement_of_general: "General",
    statement_of_cliente: "Cliente",
    statement_of_proveedor: "Proveedor",
    statement_of_oficina: "Sucursal",
    opening_balance: "Saldo inicial",
    closing_balance: "Saldo final",
    total_charges: "Total cargos",
    total_credits: "Total abonos",
    movement: "Movimiento",
    charge: "Cargo",
    credit: "Abono",
    no_movements: "Sin movimientos en el periodo",
    pick_statement_entity: "Elige el tipo y la entidad para ver el extracto",
    // Invoice settings
    invoice_settings: "Ajustes de facturación",
    invoice_settings_hint: "Datos y estilo que aparecen en todas tus facturas y extractos",
    company_data: "Datos de la empresa",
    invoice_style: "Estilo de la factura",
    brand_color: "Color de marca",
    show_logo: "Mostrar logo",
    logo_size: "Tamaño del logo (pt)",
    show_iban: "Mostrar datos bancarios",
    footer_text: "Texto del pie",
    default_remarks: "Observaciones por defecto",
    save_settings: "Guardar ajustes",
    settings_saved: "Ajustes guardados",
    legal_name: "Razón social",
    prefix: "Prefijo",
    branch_profiles: "Datos fiscales por sucursal",
    branch_profiles_hint: "Solo tú como admin defines qué datos salen en las facturas de cada sucursal",
    new_branch_profile: "Nueva sucursal",
    // Client portal
    my_invoices: "Mis facturas",
    my_invoices_hint: "Tus facturas, tu saldo y tu extracto de cuenta",
    no_invoices_yet: "Todavía no tienes facturas",
    download_statement: "Descargar extracto",
    linked_shipment: "Envío ligado",
    // Fase B/C
    surcharge_fixed: "Recargo fijo",
    surcharge_unit: "Recargo/unidad",
    extra_days: "Días extra",
    surcharge_hint: "El recargo por unidad se multiplica por los kg, CBM o pallets cotizados",
    province_surcharge: "Recargo provincia",
    package_code: "Código de paquete",
    package_notes: "Observaciones",
    add_note_placeholder: "Escribe una observación...",
    note_public: "Visible al cliente",
    no_notes: "Sin observaciones",
    state_label_created: "Etiqueta creada",
    state_received_warehouse: "Recibido en almacén",
    locations: "Ubicaciones WMS",
    zone: "Zona",
    loc_type_storage: "Almacenaje",
    loc_type_receiving: "Recepción",
    loc_type_dispatch: "Despacho",
    loc_type_quarantine: "Cuarentena",
    loc_type_damage: "Dañados",
    loc_type_cross_dock: "Cross-dock",
    loc_type_pending: "Pendiente",
    reception_date: "Fecha de recepción",
    label_received: "Etiqueta recibida en almacén",
    departure_date: "Fecha de salida",
    packages_in_master: "Paquetes del envío",
    subject: "Asunto",
    email_notifications: "Notificaciones por email",
    email_sender: "Remitente",
    email_domain_ok: "Dominio verificado",
    email_domain_pending: "Dominio sin verificar",
    email_why_failing: "Por qué no llegan los emails a tus clientes",
    email_fix_steps: "Resend solo permite enviar a tu propio correo mientras no verifiques un dominio. Entra en resend.com/domains, verifica tu dominio (por ejemplo meoscargo.com) y luego cambia SENDER_EMAIL a algo como no-reply@meoscargo.com. Después, los emails llegarán a cualquier cliente.",
    email_open_diagnostics: "Abrir diagnóstico",
    email_sender: "Remitente",
    email_send_test: "Enviar prueba",
    email_test_placeholder: "correo@destino.com",
    email_test_ok: "Email enviado",
    email_test_fail: "El envío ha fallado",
    email_sent: "Enviado",
    email_failed: "Fallido",
    email_requested: "Pedidos",
    email_delivered: "Entregados",
    email_bounced: "Rebotados",
    email_errors: "Errores",
    email_resend: "Reenviar",
    email_resent: "Correo reenviado",
    optional: "Opcional",
    dest_province: "Provincia de destino",
    dest_provinces: "Provincias de destino ofrecidas",
    dest_provinces_hint: "Añade las provincias/ciudades a las que ofreces esta ruta. Marca la casilla si el cliente está obligado a elegir una.",
    no_dest_provinces: "Sin provincias: el cliente podrá escribirla libremente",
    add_province: "Añadir provincia",
    province_mandatory: "Obligatoria para el cliente",
    province_optional_hint: "Opcional · habilita precio de sucursal",
    // Labels → boxes flow
    boxes_from_labels_hint: "Crea las etiquetas primero y luego añádelas aquí como cajas del envío master",
    labels_flow_hint: "Flujo: 1) Crea e imprime la etiqueta · 2) Añádela como caja en un Envío Master · 3) Asigna el master a un manifiesto/viaje",
    add_from_labels: "Añadir desde etiquetas",
    add_selected: "Añadir seleccionadas",
    no_available_labels: "No hay etiquetas disponibles. Créalas en la sección Etiquetas.",
    label_available: "Disponible",
    label_used: "Usada",
    used_in: "Usada en",
    manual_code: "Código manual",
    search_code: "Buscar código, cliente o contenido...",
    box_code: "Código de caja",
    // Accounting
    accounting: "Contabilidad",
    acc_tab_summary: "Resumen",
    acc_tab_expenses: "Gastos",
    acc_tab_invoices: "Facturas",
    acc_tab_payments: "Cobros",
    acc_scope_global: "Vista global de todas las sucursales",
    acc_scope_branch: "Solo puedes añadir gastos, crear facturas y registrar cobros",
    new_expense: "Nuevo gasto",
    new_invoice: "Nueva factura",
    new_payment: "Nuevo cobro",
    invoiced: "Facturado",
    collected: "Cobrado",
    available: "Disponible",
    pending_collection: "Pendiente de cobro",
    total_expenses: "Gastos",
    profit: "Beneficio",
    expenses: "gastos",
    invoices: "facturas",
    payments: "cobros",
    bucket_current: "Al día",
    bucket_1_30: "1-30 días",
    bucket_31_60: "31-60 días",
    bucket_61_90: "61-90 días",
    bucket_90_plus: "+90 días",
    statement_of_client: "Extracto de cliente",
    statement_of_supplier: "Extracto de proveedor",
    category: "Categoría",
    supplier: "Proveedor",
    amount: "Importe",
    vat: "IVA %",
    payment_method: "Método de pago",
    invoice: "Factura",
    invoice_number: "Nº factura",
    due_date: "Vencimiento",
    invoice_lines: "Líneas de factura",
    qty: "Cant.",
    unit_price: "Precio unit.",
    balance: "Saldo",
    by_office: "Por sucursal",
    by_category: "Por categoría",
    from_date: "Desde",
    to_date: "Hasta",
    all_offices: "Todas las sucursales",
    office: "Sucursal",
    who: "Quién",
    inv_status_pendiente: "Pendiente",
    inv_status_parcial: "Parcial",
    inv_status_pagada: "Pagada",
    exp_cat_combustible: "Combustible",
    exp_cat_alquiler: "Alquiler",
    exp_cat_salarios: "Salarios",
    exp_cat_aduanas: "Aduanas",
    exp_cat_transporte: "Transporte",
    exp_cat_suministros: "Suministros",
    exp_cat_otros: "Otros",
    pay_transferencia: "Transferencia",
    pay_efectivo: "Efectivo",
    pay_tarjeta: "Tarjeta",
    pay_bizum: "Bizum",
    pay_cheque: "Cheque",
    pay_credito: "Crédito",
    discount: "Descuento",
    switch_to_percent: "Cambiar a porcentaje",
    switch_to_amount: "Cambiar a importe",
    use_default_remarks: "Usar predeterminado",
    notes_placeholder: "Añade más información visible en la factura…",
    // Backups
    backups: "Copias de seguridad",
    run_backup: "Hacer backup ahora",
    backup_done: "Backup completado",
    no_backups: "Aún no hay copias de seguridad",
    backup_schedule: "Programación",
    backup_schedule_value: "Automático cada día a las 03:00 UTC",
    backup_where: "Dónde se guarda",
    backup_where_value: "Emergent Object Storage · meoscargo/backup/AAAAMMDD/",
    backup_restore: "Restauración",
    size: "Tamaño",
    file: "Archivo",
    download: "Descargar",
    refresh: "Actualizar",
    new_package: "Nuevo paquete",
    package: "Paquete",
    packages_flow_hint: "Recepción en oficina → etiqueta → clasificación → salida de oficina → verificación en hub → MASTER → manifest",
    carrier: "Transportista",
    carrier_tracking: "Tracking del transportista",
    internal_tracking: "Tracking interno",
    service_type: "Tipo de servicio",
    origin_city: "Ciudad origen",
    dest_country: "País destino",
    dest_city: "Ciudad destino",
    length_cm: "Largo (cm)",
    width_cm: "Ancho (cm)",
    height_cm: "Alto (cm)",
    declared: "Declarado",
    received_val: "Recibido",
    flow_state: "Estado del flujo",
    express: "Express",
    reception_office: "Oficina de recepción",
    auto_cbm_hint: "El CBM se calcula automáticamente con las dimensiones",
    office_exits: "Salidas de oficina",
    new_office_exit: "Nueva salida",
    office_exit: "Salida de oficina",
    hub_destination: "Hub destino",
    add_packages: "Añadir paquetes",
    scan_or_type: "Escanea o escribe el código",
    close_exit: "Cerrar salida y enviar al hub",
    hub_reception: "Recepción en almacén",
    start_reception: "Iniciar recepción",
    reception_ok: "RECEPCIÓN OK",
    reception_incidents: "RECEPCIÓN CON INCIDENCIAS",
    expected_totals: "Esperado",
    received_totals: "Recibido",
    physical_state: "Estado físico",
    damaged: "Dañado",
    state_ok: "Correcto",
    scan_package: "Escanear paquete",
    pending_scan: "Pendiente de escanear",
    verified: "Verificado",
    masters: "Masters",
    new_master: "Nuevo MASTER",
    master: "MASTER",
    transport_ref: "Vuelo / barco / camión",
    etd: "ETD",
    eta: "ETA",
    close_master: "Cerrar MASTER",
    master_manifest: "Manifest del MASTER",
    add_to_master: "Añadir al MASTER",
    added_ok: "Añadidos",
    rejected_items: "Rechazados",
    force_admin: "Autorización especial (solo admin)",
    total_packages: "Total paquetes",
    total_units: "Total unidades",
    total_cbm: "CBM total",
    exit_abierta: "Abierta",
    exit_en_recepcion: "En recepción",
    exit_en_transito: "En tránsito al hub",
    exit_recibida_hub: "Recibida en hub",
    exit_recibida_con_incidencias: "Recibida con incidencias",
    master_abierto: "Abierto",
    master_cerrado: "Cerrado",
    master_en_transito: "En tránsito",
    master_recibido_destino: "Recibido en destino",
    master_entregado: "Entregado",
    fs_recibido_oficina: "Recibido en oficina",
    fs_etiquetado: "Etiquetado",
    fs_clasificado: "Clasificado",
    fs_en_salida: "En salida de oficina",
    fs_transito_hub: "En tránsito al hub",
    fs_recibido_hub: "Recibido en hub",
    fs_verificado_hub: "Verificado en hub",
    fs_en_master: "En MASTER",
    fs_master_cerrado: "MASTER cerrado",
    fs_en_transito: "En tránsito",
    fs_recibido_destino: "Recibido en destino",
    fs_entregado: "Entregado",
    inc_diferencia_peso: "Diferencia de peso",
    inc_diferencia_unidades: "Diferencia de unidades",
    inc_diferencia_dimensiones: "Diferencia de dimensiones",
    inc_diferencia_cbm: "Diferencia de CBM",
    inc_etiqueta_incorrecta: "Etiqueta incorrecta",
    inc_tracking_incorrecto: "Tracking incorrecto",
    inc_destino_incorrecto: "Destino incorrecto",
    inc_transporte_incorrecto: "Tipo de transporte incorrecto",
    inc_documentacion: "Problema de documentación",
    inc_otra: "Otra incidencia",
    currencies: "Monedas",
    exchange_rates: "Tipos de cambio",
    base_currency: "Moneda base",
    totals_by_currency: "Totales por moneda",
    converted_total: "Total convertido",
    save_rates: "Guardar tipos de cambio",
    rate_hint: "Valor de 1 unidad en la moneda base",
    timeline: "Trazabilidad",
    grupaje_flow: "Flujo de grupaje",
    open_detail: "Ver detalle",
    no_office_exits: "Aún no hay salidas de oficina",
    no_masters: "Aún no hay masters",
    no_packages: "Aún no hay paquetes",
    legacy: "Histórico",
    legacy_notice: "Pantalla histórica (anterior al flujo de grupaje). El flujo actual es: 1 Paquetes → 2 Salidas de oficina → 3 Recepción en almacén → 4 Masters (con su Manifest) → 5 Trazabilidad.",
    master_hint: "El MASTER agrupa los paquetes verificados que viajan juntos (vuelo, barco o camión). El MANIFEST es su documento PDF con la lista de paquetes y los totales: se genera desde el propio MASTER.",
    stalled_alert: "{n} paquete(s) llevan más de {d} días recibidos en el hub sin salir en ningún MASTER.",
    view_only_stalled: "Ver solo los parados",
    no_movement: "sin movimiento",
    days: "días",
    edit_access: "Editar datos de acceso",
    leave_blank_keep: "Déjalo vacío para mantener la contraseña actual.",
    access_updated: "Datos de acceso actualizados",
    relogin_needed: "Has cambiado tu propia contraseña: vuelve a iniciar sesión.",
    scan_qr_track: "Escanea el QR para ver la trazabilidad",
    stalled_none: "Ningún paquete lleva más de {d} días en el hub sin salir en un MASTER.",
    mixed: "Mixto",
    mixed_hint: "El trayecto oficina → almacén puede llevar todos los tipos de transporte en el mismo vehículo: el almacén los recibe y los clasifica. Elige un tipo concreto solo si quieres que la salida acepte únicamente paquetes de ese tipo.",
    hub_direct: "El cliente trae el paquete directo al HUB",
    hub_direct_hint: "Se registra, se clasifica, se verifica y entra en el inventario del almacén en un solo paso, sin salida de oficina. Queda disponible para añadirlo a un MASTER.",
  },
  en: {
    dir: "ltr",
    app_name: "MEOS CARGO",
    app_tagline: "Professional shipping platform",
    login_title: "Sign in",
    user_or_email: "Username or Email",
    password: "Password",
    enter: "Sign in",
    demo_users: "Demo users:",
    login_error: "Invalid username or password",
    logout: "Sign out",
    dashboard: "Dashboard",
    quote_shipping: "Get a Quote",
    clients: "Clients",
    shipments: "Shipments",
    own_routes: "Own Routes",
    prices_margins: "Prices & Margins",
    select_office: "Choose the office",
    main_office: "Country's main office",
    exp_office_hint: "The expense only appears in the accounting of the office you pick.",
    orphans_title: "There are accounting records with no office assigned",
    orphans_hint: "No branch can see them. Assign an office so they show up in its accounting.",
    orphans_adopt: "Adopt into that office",
    attach_receipt: "Attach invoice / receipt",
    download_pdf: "Download PDF",
    expense_voucher: "Expense voucher",
    payment_voucher: "Payment voucher",
    provider_ranking: "Provider spend ranking",
    total_payable: "Total payable",
    overdue: "Overdue",
    upcoming_dues: "Upcoming dues",
    overdue_bills: "Overdue bills",
    upcoming_bills: "Upcoming bills",
    attachment: "Attachment",
    attach_bill: "Attach bill / image",
    account_code: "Account code",
    search_users: "Search by name, account code or ID",
    main: "Main",
    venc_vencida: "Overdue",
    venc_proxima: "Due soon",
    venc_vigente: "Current",
    venc_sin_vencimiento: "No due date",
    inbound_master_actions: "This shipment is heading to your office",
    us_owe: "They owe us",
    we_owe: "We owe",
    last: "last",
    inbound_masters: "Inbound shipments",
    inbound_packages_hint: "packages heading to your office",
    client_special_pricing: "Client special pricing",
    client_special_pricing_hint: "These prices apply automatically when the client quotes or when someone quotes on their behalf.",
    volumetric_rules: "Volumetric Rules",
    users: "Users",
    api: "API",
    language: "Language",
    save: "Save",
    cancel: "Cancel",
    new: "New",
    delete: "Delete",
    edit: "Edit",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    status: "Status",
    name: "Name",
    email: "Email",
    username: "Username",
    role: "Role",
    admin: "Administrator",
    ventas: "Sales",
    operaciones: "Operations",
    cliente: "Client",
    welcome: "Welcome",
    quick_access: "Quick access",
    total_users: "Users",
    active_routes: "Active routes",
    air_divisor: "Air Divisor",
    sea_divisor: "Sea Divisor",
    quote_type: "Transport type",
    aereo: "Air",
    terrestre: "Ground",
    maritimo: "Sea",
    origin_country: "Origin country",
    destination_country: "Destination country",
    select_option: "Select...",
    china_city_origin: "Origin city in China",
    china_notice: "For Syria, Iraq and Lebanon, only Guangzhou or Yiwu are allowed",
    postal_origin: "Origin ZIP (Europe)",
    postal_dest: "Destination ZIP (Europe)",
    cargo_type: "Cargo type",
    cargo_kg: "Kilograms (KG)",
    cargo_cbm: "CBM (cubic meters)",
    cargo_pallets: "Pallets",
    length: "Length (cm)",
    width: "Width (cm)",
    height: "Height (cm)",
    weight_kg: "Weight (kg)",
    cbm_amount: "CBM quantity",
    total_weight: "Total weight (kg)",
    pallets_qty: "Number of pallets",
    hs_code: "HS Code (optional)",
    calculate: "Calculate prices",
    select_route: "Select",
    empty_quote: "Choose origin, destination and transport type",
    empty_quote_sub: "Supports Air, Ground and Sea worldwide",
    meos_route: "★ Meos Route",
    estimated_rates: "Estimated rates",
    origin: "Origin",
    destination: "Destination",
    price_base: "Base price",
    price_kg: "Price per KG",
    price_cbm: "Price per CBM",
    price_pallet: "Price per Pallet",
    transit_days: "Transit days",
    service_name: "Service name",
    mode: "Mode",
    all_modes: "All modes",
    new_route: "New Route",
    edit_route: "Edit Route",
    routes_note: "Own routes have priority over external APIs",
    fullname: "Full name",
    new_user: "New User",
    user_created: "User created",
    user_exists: "Username or email already exists",
    general_margin: "General margin (%)",
    guide_charge: "Guide charge ($)",
    air_divisor_full: "Air Divisor (IATA standard = 6000)",
    sea_divisor_full: "Sea Divisor (standard = 1000)",
    formula_air: "Formula: (L × W × H) / divisor = volumetric kg",
    formula_sea: "Used to convert CBM into estimated weight",
    saved: "Saved successfully",
    deleted: "Deleted",
    confirm_delete: "Confirm delete?",
    no_clients: "No registered clients",
    shipments_soon: "Shipments module (coming soon)",
    tracking_code: "Tracking code",
    assign_client: "Assigned client",
    description: "Description / cargo",
    estimated_date: "Estimated date",
    internal_notes: "Internal notes",
    new_shipment: "New shipment",
    my_shipments: "My shipments",
    my_registered_packages: "My registered packages",
    incoming_shipment: "Incoming",
    backdate_label: "Historic date (admin)",
    backdate_hint: "Admin only — register the package with a past date",
    track: "Track",
    flow_clasificado: "Classified",
    flow_en_salida: "In transit (office)",
    flow_transito_hub: "In transit to hub",
    flow_recibido_hub: "Received at hub",
    flow_verificado_hub: "Verified",
    flow_en_master: "In master",
    flow_master_cerrado: "Master closed",
    flow_entregado: "Delivered",
    merch_charge_type: "Charge type",
    merch_per_shipment: "Per shipment",
    merch_per_kg: "Per kilogram",
    all_shipments: "All shipments",
    sales_crm: "Sales · CRM",
    crm_quotes: "Quotes",
    crm_followups: "Follow-ups",
    crm_new_lead: "New client",
    crm_no_leads: "No clients registered yet",
    crm_no_history: "No history yet. Log the first call",
    crm_log_call: "Log call",
    crm_new_quote: "Quote",
    crm_add_task: "Follow-up",
    crm_timeline: "360° history",
    crm_no_results: "No results",
    crm_leads_search_ph: "Search by name, phone, email...",
    crm_call_when: "When",
    crm_call_reason: "Reason",
    crm_caller: "Who called",
    crm_request: "What they need",
    crm_call_notes: "Important information",
    crm_next_step: "Next follow-up",
    crm_action: "Action",
    crm_when: "When",
    crm_service: "Service",
    crm_terms: "Terms",
    crm_valid_until: "Valid until",
    crm_task_type: "Type",
    crm_task_detail: "Detail",
    crm_source: "Source",
    crm_company: "Company / client",
    crm_contact_person: "Contact person",
    crm_notes: "Notes",
    crm_new_leads: "New clients (7d)",
    crm_calls_today: "Calls today",
    crm_quotes_pending: "Pending quotes",
    crm_tasks_today: "Follow-ups today",
    crm_tasks_overdue: "Overdue",
    crm_tasks_upcoming: "Next 7d",
    crm_quotes_won: "Accepted",
    crm_quotes_lost: "Lost",
    crm_no_tasks_today: "No follow-ups scheduled for today",
    crm_no_overdue: "No overdue. Great job",
    crm_no_tasks: "No tasks in this bucket",
    crm_no_quotes: "No quotes",
    crm_seed_confirm: "Load 3 sample clients into the CRM?",
    crm_seed_hint_title: "No data yet",
    crm_seed_hint_desc: "Load 3 sample clients with calls and quotes to explore the CRM",
    crm_seed_btn: "Load samples",
    crm_stats: "Statistics",
    crm_route_data: "Requested route",
    crm_stats_total: "Inquiries",
    crm_stats_by_route: "Inquiries by route",
    crm_stats_empty: "No quotes with route data in the selected range",
    destination_city: "Destination city",
    transport: "Mode",
    from: "From",
    to: "To",
    crm_mark_done: "Mark as done",
    crm_state_nueva: "New",
    crm_state_cotizada: "Quoted",
    crm_state_pendiente: "Pending",
    crm_state_seguimiento: "Follow-up",
    crm_state_aceptada: "Accepted",
    crm_state_confirmada: "Confirmed",
    crm_state_rechazada: "Rejected",
    crm_state_perdida: "Lost",
    crm_state_cancelada: "Cancelled",
    crm_type_llamar: "Call",
    crm_type_enviar_precio: "Send price",
    crm_type_enviar_docs: "Send docs",
    crm_type_esperar_confirmacion: "Await confirmation",
    crm_type_confirmar_envio: "Confirm shipment",
    crm_type_recontactar: "Recontact",
    crm_type_otro: "Other",
    crm_reason_cotizacion: "Quote",
    crm_reason_seguimiento: "Follow-up",
    crm_reason_complaint: "Complaint",
    crm_reason_reclamacion: "Complaint",
    crm_reason_informacion: "Information",
    crm_reason_info: "Information",
    crm_reason_quote: "Quote",
    crm_reason_followup: "Follow-up",
    crm_origin_call: "Call",
    crm_origin_web: "Web",
    crm_origin_referral: "Referral",
    crm_origin_trade_show: "Trade show",
    crm_origin_other: "Other",
    crm_new_request: "Add New Request",
    crm_request_contact: "Contact details",
    crm_request_route: "Shipping route",
    crm_request_cargo: "Cargo details",
    crm_contact_name: "Client name",
    crm_from_country: "From country",
    crm_to_country: "To country",
    crm_shipping_mode: "Shipping mode",
    trace_label_created: "Label created",
    trace_received_warehouse: "Received at warehouse",
    trace_grupaje_recibido_oficina: "Received at office",
    trace_grupaje_etiquetado: "Labeled",
    trace_grupaje_clasificado: "Classified",
    trace_grupaje_actualizado: "Data updated",
    trace_grupaje_anadido_salida: "Added to office exit",
    trace_grupaje_retirado_salida: "Removed from exit",
    trace_grupaje_salida_oficina: "Office exit · in transit to hub",
    trace_grupaje_recibido_hub: "Received at HUB",
    trace_grupaje_verificado_hub: "Verified OK at HUB",
    trace_grupaje_faltante: "Missing at reception",
    trace_grupaje_anadido_master: "Added to MASTER",
    trace_grupaje_retirado_master: "Removed from MASTER",
    trace_grupaje_master_cerrado: "MASTER closed",
    trace_grupaje_en_transito: "In transit to destination",
    trace_grupaje_recibido_destino: "Received at destination",
    trace_grupaje_entregado: "Delivered",
    trace_inv_received: "Received into inventory",
    trace_inv_packaged: "Packaged",
    trace_inv_dispatched: "Dispatched",
    trace_picked_by_driver: "Picked up by driver",
    trace_in_dispatch_manifest: "In dispatch manifest",
    trace_ship_status_recibido: "Status: Received",
    trace_ship_status_despacho: "Status: Dispatched",
    trace_ship_status_en_aduana: "Status: At customs",
    trace_ship_status_en_reparto: "Status: Out for delivery",
    trace_ship_status_entregado: "Status: Delivered",
    trace_audit_create_shipment: "Shipment created",
    trace_audit_update_shipment: "Shipment updated",
    trace_audit_delete_shipment: "Shipment deleted",
    trace_audit_create_label: "Label created",
    trace_audit_update_label: "Label updated",
    trace_audit_delete_label: "Label deleted",
    trace_audit_receive: "Reception logged",
    trace_audit_dispatch: "Dispatch logged",
    trace_audit_assign_master: "Assigned to master",
    trace_audit_unassign_master: "Removed from master",
    trace_audit_create_manifest: "Manifest created",
    trace_audit_close_manifest: "Manifest closed",
    trace_audit_scan: "Scan logged",
    trace_audit_status_change: "Status changed",
    trace_audit_invoice: "Invoice issued",
    trace_audit_payment: "Payment logged",
    trace_audit_incident: "Incident logged",
    state_received_office: "Received at office",
    state_labeled: "Labeled",
    state_added_master: "Added to MASTER",
    state_added_office_exit: "Added to office exit",
    state_in_transit: "In transit to destination",
    state_received_destination: "Received at destination",
    status_recibido: "Received",
    status_despacho: "Dispatched",
    status_en_aduana: "At customs",
    status_en_reparto: "Out for delivery",
    status_entregado: "Delivered",
    update_status: "Update status",
    status_history: "Status history",
    shipment_created: "Shipment created",
    no_shipments: "You have no shipments yet",
    no_shipments_admin: "No shipments registered",
    tracking_placeholder: "MEOS-2026-000123",
    client: "Client",
    no_route_available: "No route configured by admin for this origin/destination",
    price_breakdown: "Price breakdown",
    subtotal: "Subtotal",
    margin: "Margin",
    guide_fee: "Guide fee",
    total: "Total",
    view_details: "View details",
    base_prices_tiers: "Base prices and tiers",
    port_origin: "Origin port/airport",
    port_dest: "Destination port/airport",
    observations: "Observations",
    fcl: "Full Container Load (FCL)",
    container_type: "Container type",
    container_20: "20 ft",
    container_40: "40 ft",
    container_40hc: "40 HC",
    container_weight: "Container weight (kg)",
    cargo_weight: "Cargo weight (kg)",
    total_weight_fcl: "Total weight",
    price_20ft: "Price 20ft ($)",
    price_40ft: "Price 40ft ($)",
    price_40hc: "Price 40HC ($)",
    public_tracking: "Public tracking",
    track_placeholder: "Enter your tracking code",
    track: "Track",
    notifications: "Notifications",
    no_notifications: "No notifications",
    mark_all_read: "Mark all as read",
    currency: "Currency",
    sucursal: "Branch office",
    office: "Office / Branch",
    assigned_office: "Assigned office",
    google_signin: "Continue with Google",
    or: "or",
    services_enabled: "Services enabled on this route",
    services_hint: "Only checked cargo types will appear when quoting this route.",
    price_kg_short: "KG",
    pending: "Pending",
    delivered_this_month: "Delivered this month",
    recent_shipments: "Recent shipments",
    notif_shipment_created_title: "New shipment {code}",
    notif_shipment_created_msg: "Your shipment {origen} → {destino} has been created",
    notif_status_change_title: "Update {code}",
    notif_status_change_msg: "Your shipment is now: {status}",
    history: "History",
    quotes: "Quotes",
    no_history: "No quotes yet",
    search: "Search...",
    province: "Province / State",
    sucursal_price: "Branch price",
    sucursal_prices_hint: "Special price applied only to branch users or clients entering this province.",
    ship_label: "Shipping label",
    print_label: "Print label",
    // CRM
    client_type: "Client type",
    private: "Private",
    company: "Company",
    address: "Address",
    city: "City",
    country: "Country",
    postal_code: "Postal code",
    phone: "Phone",
    phone_alt: "Alternate phone",
    rfc_nit: "Tax ID (VAT / EIN / RFC)",
    doc_id: "ID document",
    sector: "Industry / Sector",
    contact_person: "Contact person",
    notes: "Notes",
    assigned_branch: "Assigned branch",
    auto_by_province: "Auto by province",
    edit_client: "Edit client",
    new_client: "New client",
    search_clients: "Search by name, email, company or phone...",
    reset_password: "Reset password",
    reset_password_manual: "Set password manually",
    reset_password_email: "Email a temporary password",
    new_password: "New password",
    password_reset_success: "Password updated",
    password_sent_email: "Password emailed to",
    generated_password: "Generated password",
    copy: "Copy",
    copied: "Copied",
    close: "Close",
    personal_info: "Personal info",
    company_info: "Company info",
    contact_info: "Contact",
    address_info: "Address",
    complete_profile: "Complete your profile",
    complete_profile_desc: "We need a few details to route your shipments through the right branch.",
    skip_for_now: "Skip for now",
    save_profile: "Save profile",
    profile_updated: "Profile updated",
    provincias_covered: "Provinces covered by this branch",
    provincias_hint: "Comma-separated list of provinces. Clients from any of these will be auto-assigned to this branch.",
    registered_by: "Registered by",
    self_registered: "Self-registered",
    show_password: "Show",
    hide_password: "Hide",
    optional: "optional",
    // Shipment address fields
    sender: "Sender",
    receiver: "Receiver",
    street: "Street",
    number: "Number",
    tax_id: "Tax ID / VAT",
    address_reference: "Address reference",
    alias: "Alias",
    save_address: "Save address",
    address_book: "Saved addresses",
    load_from_book: "Load from address book",
    minimize: "Minimize",
    expand: "Expand",
    // Warehouses / Inventory / Schedules / Countries
    countries: "Countries",
    new_country: "New country",
    warehouses: "Warehouses",
    warehouse: "Warehouse",
    new_warehouse: "New warehouse",
    no_warehouses: "No warehouses",
    warehouse_required: "Select a warehouse",
    inventory: "Inventory",
    inbound: "Inbound",
    outbound: "Outbound",
    scan: "Scan",
    scan_barcode: "Barcode scanner",
    scan_hint: "Focus scanner or paste code and press Enter",
    scan_found: "Found",
    not_found: "Not found",
    location: "Location",
    units: "Units",
    state: "State",
    state_received: "Received",
    state_packaged: "Packaged",
    state_dispatched: "Dispatched",
    no_inventory: "No inventory items",
    schedules: "Schedules",
    admin_editable: "Admin editable only",
    read_only: "Read only",
    container: "Container",
    route: "Route",
    estimated_departure: "Est. departure",
    confirmed_departure: "Conf. departure",
    estimated_arrival: "Est. arrival",
    pending_approvals: "Pending approvals",
    approve: "Approve",
    reject: "Reject",
    account_pending: "Your account is pending approval",
    account_pending_desc: "An admin will review your registration shortly. We'll email you when ready.",
    branch_pricing: "Branch pricing",
    add_branch_price: "Add branch price",
    select_branch: "Select branch",
    role_almacen: "Warehouse",
    container_number: "Container no.",
    // Voyages, manifests, labels
    voyages: "Voyages / Departures",
    voyage: "Voyage",
    new_voyage: "New voyage",
    no_voyages: "No voyages",
    port_from: "Port of origin",
    port_to: "Port of destination",
    vessel: "Vessel / Ship no.",
    cut_off: "Cut-off",
    departure: "Departure",
    arrival: "Arrival",
    custom_fields: "Custom fields",
    field_name: "Field name",
    value: "Value",
    add: "Add",
    air: "Air",
    sea: "Sea",
    ground: "Ground",
    vehicle: "Vehicle",
    driver: "Driver",
    new_manifest: "New manifest",
    no_manifests: "No manifests",
    manifest_sucursal_out: "Branch outbound",
    manifest_hub_in: "Hub inbound",
    manifest_hub_out: "Hub outbound",
    receive: "Receive",
    received: "Received",
    receive_manifest: "Receive manifest",
    scan_manifest_barcode: "Scan manifest barcode",
    mark_missing: "Mark missing package",
    missing: "Missing",
    all_received_hint: "If you don't mark anything, all packages will be received",
    confirm_receipt: "Confirm receipt",
    note_optional: "Note (optional)",
    select: "Select",
    assign_shipments: "Assign shipments",
    labels: "Labels",
    new_label: "New label",
    no_labels: "No labels yet",
    packages: "Packages",
    dimensions: "Dimensions",
    reference: "Reference",
    content: "Contents",
    save_and_print: "Create + Print",
    print: "Print",
    camera: "Camera",
    camera_scan: "Scan with camera",
    stop: "Stop",
    manifests: "Manifests",
    // Scanner workflow (enterprise)
    scanner_mode: "Scanner mode",
    mode_receive_manifest: "Receive with manifest",
    mode_receive_direct: "Direct receive",
    mode_prepare_exit: "Prepare exit",
    mode_receive_manifest_desc: "Scan the manifest and validate each package",
    mode_receive_direct_desc: "Receive packages without a prior manifest",
    mode_prepare_exit_desc: "Scan packages and auto-generate exit manifest",
    step_1_scan_manifest: "Step 1 · Scan the manifest",
    step_2_scan_packages: "Step 2 · Scan each package",
    step_3_close_reception: "Step 3 · Close reception",
    expected: "Expected",
    scanned: "Scanned",
    matches: "Matches",
    extras: "Extras",
    close_reception: "Close reception",
    open_reception: "Start reception",
    package_ok: "Package OK",
    package_extra: "Extra package (unexpected)",
    package_duplicate: "Already scanned",
    unknown_package: "Unknown package",
    quick_create_shipment: "Quick create shipment",
    generate_exit_manifest: "Generate exit manifest",
    exit_destination: "Exit destination",
    scanned_packages: "Scanned packages",
    incidents: "Incidents",
    incident_faltante: "Missing",
    incident_extra: "Extra",
    incident_dano: "Damage",
    incident_retraso: "Delay",
    severity: "Severity",
    severity_low: "Low",
    severity_medium: "Medium",
    severity_high: "High",
    audit_trail: "Internal audit",
    public_tracking: "Public tracking",
    reception_summary: "Reception summary",
    of: "of",
    remove: "Remove",
    reset: "Reset",
    photo_url: "Photo URL (optional)",
    warehouse_id_required: "Warehouse required",
    client_required_new_pkg: "Select a client to create the shipment",
    incidents_created: "Incidents created",
    view_audit: "View audit",
    action: "Action",
    when: "When",
    who: "Who",
    reception_started: "Reception started",
    reception_closed: "Reception closed",
    // Albaranes / Locations / voyage detail extra keys
    package_receipt: "Delivery note",
    new_delivery_note: "New delivery note",
    no_delivery_notes: "No delivery notes",
    incidence_optional: "Incidence (optional)",
    save_and_pdf: "Save + PDF",
    package_weight_kg: "Weight kg",
    packages_count: "Packages",
    receiver_name: "Receiver name",
    address: "Address",
    country: "Country",
    city: "City",
    pickup: "Pickup",
    delivery: "Delivery",
    receiver: "Receiver",
    shipment: "Shipment",
    tracking: "Tracking",
    global_audit: "Global audit",
    zone_required: "Zone *",
    aisle_required: "Aisle *",
    warehouse_required: "Warehouse *",
    rack_short: "Rack",
    level: "Level",
    position_short: "Pos.",
    cap_units: "Cap. pkgs",
    new_location: "New location",
    no_locations_add_first: "No locations. Add the first one.",
    all_warehouses: "All warehouses",
    create: "Create",
    auto_prefix: "Auto",
    signature_receiver: "Receiver signature",
    clear: "Clear",
    courier: "Courier",
    courier_documentos: "Documents",
    courier_pasaporte: "Passport",
    courier_goods: "Goods",
    locations: "WMS Locations",
    zone: "Zone",
    type: "Type",
    date_col: "Date",
    route_col: "Route",
    mode_col: "Mode",
    cargo_col: "Cargo",
    best_price_col: "Best price",
    delivery_receipts: "Delivery notes",
    // Merchandise types
    merchandise: "Merchandise",
    merchandise_types: "Merchandise types",
    merchandise_types_hint: "Route-level categories with optional surcharge + mandatory flag",
    add_merchandise_type: "Add type",
    no_merchandise_types: "No merchandise types",
    merch_name: "Name",
    merch_name_ph: "Electronics, Apparel, Fragile...",
    merch_surcharge: "Surcharge",
    mandatory: "Mandatory",
    merch_required_hint: "Select a merchandise type to continue",
    // Assign to voyage
    assign_to_voyage: "Assign to Voyage",
    select_for_dispatch: "Select for dispatch",
    select_shipments_hint: "Select at least one shipment",
    selected_shipments: "Selected shipments",
    manifest_will_be_generated: "An exit manifest will be generated",
    no_voyage_optional: "No voyage (optional)",
    manifest_name: "Manifest name",
    manifest_copy: "Manifest copy",
    assign_and_generate: "Assign & generate",
    assigned: "Assigned",
    not_found: "Not found",
    dispatch: "Dispatch",
    departure: "Departure",
    vehicle: "Vehicle",
    driver: "Driver",
    container: "Container",
    // Multi-box / master shipment
    boxes: "Boxes",
    bultos: "Pieces",
    bultos_short: "pcs",
    add_box: "Add box",
    boxes_editor_hint: "Split one shipment into multiple boxes with their own code and weight",
    no_items_single_box: "No boxes: will be created as a single-box shipment",
    print_all_labels: "All labels",
    // Report language
    report_language: "Report language",
    role_contable: "Accountant",
    contable: "Accountant",
    all: "All",
    date: "Date",
    wms_locations: "WMS Locations",
    albaranes: "Delivery notes",
    fleet: "Fleet & Drivers",
    drivers: "Drivers",
    vehicles: "Vehicles",
    driver_routes: "Delivery routes",
    new_driver: "New driver",
    new_vehicle: "New vehicle",
    new_driver_route: "New delivery route",
    no_routes_yet: "No delivery routes yet",
    no_vehicle: "No vehicle",
    stops: "Stops",
    plate: "Plate",
    brand: "Brand",
    model: "Model",
    capacity_kg: "Capacity (kg)",
    capacity_m3: "Capacity (m³)",
    insurance: "Insurance",
    license: "License",
    license_expiry: "License expiry",
    expiry_alert: "Expiring",
    veh_furgoneta: "Van",
    veh_camion: "Truck",
    veh_trailer: "Trailer",
    veh_coche: "Car",
    route_state_pendiente: "Pending",
    route_state_en_curso: "In progress",
    route_state_completada: "Completed",
    stop_pendiente: "Pending",
    stop_en_camino: "On the way",
    stop_entregado: "Delivered",
    stop_fallido: "Failed",
    stop_type_entrega: "Delivery",
    stop_type_recogida: "Pickup",
    conductor: "Driver",
    role_conductor: "Driver",
    link_user_account: "User account (for the driver app)",
    edit_driver: "Edit driver",
    edit_vehicle: "Edit vehicle",
    my_route: "My route",
    no_route_today: "You have no route assigned",
    mark_on_the_way: "Mark on the way",
    mark_delivered: "Delivered + receipt",
    mark_picked_up: "Picked up + receipt",
    mark_failed: "Failed",
    delivery_evidence: "Evidence photos (ID, goods)",
    print_receipt: "PDF receipt",
    open_maps: "Map",
    call: "Call",
    whatsapp_notify: "Notify via WhatsApp",
    optimize_route: "Optimize route",
    optimizing: "Optimizing…",
    route_optimized: "Route optimized by proximity",
    total_distance: "Total distance",
    est_arrival: "Est. arrival",
    stops_no_location: "stops without location",
    search_shipment: "Search by code, client, origin, destination…",
    no_search_results: "No results for your search",
    whatsapp_auto: "Auto WhatsApp",
    whatsapp_auto_hint: "Notify the client via WhatsApp on each status change",
    transport_mode: "Transport",
    road: "Ground",
    account_number: "Account no.",
    auto_account: "Automatic",
    download_backup_pc: "Download backup to my computer",
    email_backup_now: "Email backup now",
    backup_email_sent: "Backup emailed",
    pickup_scan: "Pickup by scan",
    pickup_scan_hint: "Scan shipments, boxes or labels and generate a pickup manifest",
    scan_or_type_code: "Scan or type the code…",
    generate_pickup_manifest: "Generate pickup manifest",
    picked_up: "Picked up",
    scan_at_least_one: "Add at least one code",
    give_entry: "Give entry",
    already_received: "This label was already received",
    recipient: "Recipient",
    label: "Label",
    trace: "Traceability",
    trace_search: "Search by track, label or box code…",
    trace_timeline: "Internal package history",
    trace_no_result: "No results for that code",
    pickups_tab: "Pickups",
    pickups_today: "Today's pickups",
    total_weight: "Total weight",
    notify_pickup_wa: "Notify pickup via WhatsApp",
    website: "Website",
    bank: "Bank",
    concept: "Concept",
    charges: "Charges",
    credits: "Credits",
    paid: "Paid",
    remarks: "Remarks",
    remarks_hint: "Leave empty to use the branch or company default text",
    edit_invoice: "Edit invoice",
    acc_tab_aging: "Overdue",
    acc_tab_suppliers: "Suppliers",
    acc_tab_branches: "Branches",
    acc_tab_statement: "Statements",
    receivables: "Client receivables",
    payables: "Supplier payables",
    outstanding_total: "Total outstanding",
    overdue_total: "Total overdue",
    days_overdue: "Days overdue",
    nothing_overdue: "No outstanding balances",
    bucket_no_vencido: "Current",
    bucket_d0_30: "1-30 days",
    bucket_d31_60: "31-60 days",
    bucket_d61_90: "61-90 days",
    bucket_d90_plus: "90+ days",
    bucket_sin_vencimiento: "No due date",
    suppliers: "Suppliers",
    supplier: "Supplier",
    new_supplier: "New supplier",
    purchase_invoices: "Purchase invoices",
    purchase_invoice: "Purchase invoice",
    new_bill: "New purchase invoice",
    bill_number: "Supplier ref.",
    new_bill_payment: "Register payment",
    owed_to_suppliers: "Owed to suppliers",
    owed_by_branches: "Owed by branches",
    branch_account: "Branch account current",
    ledger_entries: "Charges and credits",
    new_ledger_entry: "New charge / credit",
    ledger_hint: "Charge = the branch owes us · Credit = the branch settles",
    mov_cargo: "Charge",
    mov_abono: "Credit",
    mov_factura: "Invoice",
    mov_cobro: "Collection",
    mov_gasto: "Expense",
    mov_factura_compra: "Purchase invoice",
    mov_pago: "Payment",
    statement: "Statement",
    statement_type: "Statement type",
    statement_of_general: "General",
    statement_of_cliente: "Client",
    statement_of_proveedor: "Supplier",
    statement_of_oficina: "Branch",
    opening_balance: "Opening balance",
    closing_balance: "Closing balance",
    total_charges: "Total charges",
    total_credits: "Total credits",
    movement: "Movement",
    charge: "Charge",
    credit: "Credit",
    no_movements: "No movements in this period",
    pick_statement_entity: "Pick a type and entity to see the statement",
    invoice_settings: "Invoice settings",
    invoice_settings_hint: "Data and style used across all your invoices and statements",
    company_data: "Company data",
    invoice_style: "Invoice style",
    brand_color: "Brand colour",
    show_logo: "Show logo",
    logo_size: "Logo size (pt)",
    show_iban: "Show bank details",
    footer_text: "Footer text",
    default_remarks: "Default remarks",
    save_settings: "Save settings",
    settings_saved: "Settings saved",
    legal_name: "Legal name",
    prefix: "Prefix",
    branch_profiles: "Branch billing data",
    branch_profiles_hint: "Only you as admin define what appears on each branch's invoices",
    new_branch_profile: "New branch",
    my_invoices: "My invoices",
    my_invoices_hint: "Your invoices, balance and account statement",
    no_invoices_yet: "You have no invoices yet",
    download_statement: "Download statement",
    linked_shipment: "Linked shipment",
    surcharge_fixed: "Fixed surcharge",
    surcharge_unit: "Surcharge/unit",
    extra_days: "Extra days",
    surcharge_hint: "The per-unit surcharge is multiplied by the quoted kg, CBM or pallets",
    province_surcharge: "Province surcharge",
    package_code: "Package code",
    package_notes: "Observations",
    add_note_placeholder: "Write an observation...",
    note_public: "Visible to client",
    no_notes: "No observations",
    state_label_created: "Label created",
    state_received_warehouse: "Received at warehouse",
    locations: "WMS Locations",
    zone: "Zone",
    loc_type_storage: "Storage",
    loc_type_receiving: "Receiving",
    loc_type_dispatch: "Dispatch",
    loc_type_quarantine: "Quarantine",
    loc_type_damage: "Damaged",
    loc_type_cross_dock: "Cross-dock",
    loc_type_pending: "Pending",
    reception_date: "Reception date",
    label_received: "Label received at warehouse",
    departure_date: "Departure date",
    packages_in_master: "Packages in this shipment",
    subject: "Subject",
    email_notifications: "Email notifications",
    email_sender: "Sender",
    email_domain_ok: "Domain verified",
    email_domain_pending: "Domain not verified",
    email_why_failing: "Why customer emails are not arriving",
    email_fix_steps: "Resend only allows sending to your own address until you verify a domain. Go to resend.com/domains, verify your domain (e.g. meoscargo.com) and then set SENDER_EMAIL to something like no-reply@meoscargo.com. After that, emails reach any customer.",
    email_open_diagnostics: "Open diagnostics",
    email_sender: "Sender",
    email_send_test: "Send test",
    email_test_placeholder: "someone@example.com",
    email_test_ok: "Email sent",
    email_test_fail: "Sending failed",
    email_sent: "Sent",
    email_failed: "Failed",
    email_requested: "Requested",
    email_delivered: "Delivered",
    email_bounced: "Bounced",
    email_errors: "Errors",
    email_resend: "Resend",
    email_resent: "Email resent",
    optional: "Optional",
    dest_province: "Destination province",
    dest_provinces: "Destination provinces offered",
    dest_provinces_hint: "Add the provinces/cities you serve on this route. Tick the box to force the client to pick one.",
    no_dest_provinces: "No provinces: the client can type it freely",
    add_province: "Add province",
    province_mandatory: "Mandatory for the client",
    province_optional_hint: "Optional · enables branch pricing",
    boxes_from_labels_hint: "Create the labels first, then add them here as boxes of the master shipment",
    labels_flow_hint: "Flow: 1) Create and print the label · 2) Add it as a box in a Master Shipment · 3) Assign the master to a manifest/voyage",
    add_from_labels: "Add from labels",
    add_selected: "Add selected",
    no_available_labels: "No available labels. Create them in the Labels section.",
    label_available: "Available",
    label_used: "Used",
    used_in: "Used in",
    manual_code: "Manual code",
    search_code: "Search code, client or contents...",
    box_code: "Box code",
    accounting: "Accounting",
    acc_tab_summary: "Summary",
    acc_tab_expenses: "Expenses",
    acc_tab_invoices: "Invoices",
    acc_tab_payments: "Collections",
    acc_scope_global: "Global view across all branches",
    acc_scope_branch: "You can only add expenses, create invoices and register collections",
    new_expense: "New expense",
    new_invoice: "New invoice",
    new_payment: "New collection",
    invoiced: "Invoiced",
    collected: "Collected",
    available: "Available",
    pending_collection: "Outstanding",
    total_expenses: "Expenses",
    profit: "Profit",
    expenses: "expenses",
    invoices: "invoices",
    payments: "collections",
    bucket_current: "Current",
    bucket_1_30: "1-30 days",
    bucket_31_60: "31-60 days",
    bucket_61_90: "61-90 days",
    bucket_90_plus: "+90 days",
    statement_of_client: "Customer statement",
    statement_of_supplier: "Supplier statement",
    category: "Category",
    supplier: "Supplier",
    amount: "Amount",
    vat: "VAT %",
    payment_method: "Payment method",
    invoice: "Invoice",
    invoice_number: "Invoice #",
    due_date: "Due date",
    invoice_lines: "Invoice lines",
    qty: "Qty",
    unit_price: "Unit price",
    balance: "Balance",
    by_office: "By branch",
    by_category: "By category",
    from_date: "From",
    to_date: "To",
    all_offices: "All branches",
    office: "Branch",
    who: "Who",
    inv_status_pendiente: "Pending",
    inv_status_parcial: "Partial",
    inv_status_pagada: "Paid",
    exp_cat_combustible: "Fuel",
    exp_cat_alquiler: "Rent",
    exp_cat_salarios: "Payroll",
    exp_cat_aduanas: "Customs",
    exp_cat_transporte: "Transport",
    exp_cat_suministros: "Supplies",
    exp_cat_otros: "Other",
    pay_transferencia: "Bank transfer",
    pay_efectivo: "Cash",
    pay_tarjeta: "Card",
    pay_bizum: "Bizum",
    pay_cheque: "Cheque",
    pay_credito: "Credit",
    discount: "Discount",
    switch_to_percent: "Switch to percentage",
    switch_to_amount: "Switch to flat amount",
    use_default_remarks: "Use default",
    notes_placeholder: "Add any extra information visible on the invoice…",
    backups: "Backups",
    run_backup: "Run backup now",
    backup_done: "Backup completed",
    no_backups: "No backups yet",
    backup_schedule: "Schedule",
    backup_schedule_value: "Automatic daily at 03:00 UTC",
    backup_where: "Storage location",
    backup_where_value: "Emergent Object Storage · meoscargo/backup/YYYYMMDD/",
    backup_restore: "Restore",
    size: "Size",
    file: "File",
    download: "Download",
    refresh: "Refresh",
    new_package: "New package",
    package: "Package",
    packages_flow_hint: "Office reception → label → classification → office exit → hub verification → MASTER → manifest",
    carrier: "Carrier",
    carrier_tracking: "Carrier tracking",
    internal_tracking: "Internal tracking",
    service_type: "Service type",
    origin_city: "Origin city",
    dest_country: "Destination country",
    dest_city: "Destination city",
    length_cm: "Length (cm)",
    width_cm: "Width (cm)",
    height_cm: "Height (cm)",
    declared: "Declared",
    received_val: "Received",
    flow_state: "Flow state",
    express: "Express",
    reception_office: "Reception office",
    auto_cbm_hint: "CBM is calculated automatically from the dimensions",
    office_exits: "Office exits",
    new_office_exit: "New exit",
    office_exit: "Office exit",
    hub_destination: "Destination hub",
    add_packages: "Add packages",
    scan_or_type: "Scan or type the code",
    close_exit: "Close exit and send to hub",
    hub_reception: "Warehouse reception",
    start_reception: "Start reception",
    reception_ok: "RECEPTION OK",
    reception_incidents: "RECEPTION WITH INCIDENTS",
    expected_totals: "Expected",
    received_totals: "Received",
    physical_state: "Physical state",
    damaged: "Damaged",
    state_ok: "OK",
    scan_package: "Scan package",
    pending_scan: "Pending scan",
    verified: "Verified",
    masters: "Masters",
    new_master: "New MASTER",
    master: "MASTER",
    transport_ref: "Flight / vessel / truck",
    etd: "ETD",
    eta: "ETA",
    close_master: "Close MASTER",
    master_manifest: "MASTER manifest",
    add_to_master: "Add to MASTER",
    added_ok: "Added",
    rejected_items: "Rejected",
    force_admin: "Special authorisation (admin only)",
    total_packages: "Total packages",
    total_units: "Total units",
    total_cbm: "Total CBM",
    exit_abierta: "Open",
    exit_en_recepcion: "In reception",
    exit_en_transito: "In transit to hub",
    exit_recibida_hub: "Received at hub",
    exit_recibida_con_incidencias: "Received with incidents",
    master_abierto: "Open",
    master_cerrado: "Closed",
    master_en_transito: "In transit",
    master_recibido_destino: "Received at destination",
    master_entregado: "Delivered",
    fs_recibido_oficina: "Received at office",
    fs_etiquetado: "Labelled",
    fs_clasificado: "Classified",
    fs_en_salida: "In office exit",
    fs_transito_hub: "In transit to hub",
    fs_recibido_hub: "Received at hub",
    fs_verificado_hub: "Verified at hub",
    fs_en_master: "In MASTER",
    fs_master_cerrado: "MASTER closed",
    fs_en_transito: "In transit",
    fs_recibido_destino: "Received at destination",
    fs_entregado: "Delivered",
    inc_diferencia_peso: "Weight difference",
    inc_diferencia_unidades: "Units difference",
    inc_diferencia_dimensiones: "Dimensions difference",
    inc_diferencia_cbm: "CBM difference",
    inc_etiqueta_incorrecta: "Wrong label",
    inc_tracking_incorrecto: "Wrong tracking",
    inc_destino_incorrecto: "Wrong destination",
    inc_transporte_incorrecto: "Wrong transport type",
    inc_documentacion: "Documentation issue",
    inc_otra: "Other incident",
    currencies: "Currencies",
    exchange_rates: "Exchange rates",
    base_currency: "Base currency",
    totals_by_currency: "Totals by currency",
    converted_total: "Converted total",
    save_rates: "Save exchange rates",
    rate_hint: "Value of 1 unit in the base currency",
    timeline: "Traceability",
    grupaje_flow: "Groupage flow",
    open_detail: "View detail",
    no_office_exits: "No office exits yet",
    no_masters: "No masters yet",
    no_packages: "No packages yet",
    legacy: "Legacy",
    legacy_notice: "Legacy screen (before the groupage flow). The current flow is: 1 Packages → 2 Office exits → 3 Warehouse reception → 4 Masters (with their Manifest) → 5 Traceability.",
    master_hint: "The MASTER groups the verified packages travelling together (flight, vessel or truck). The MANIFEST is its PDF document with the package list and totals, generated from the MASTER itself.",
    stalled_alert: "{n} package(s) have been at the hub for more than {d} days without leaving in any MASTER.",
    view_only_stalled: "Show only stalled",
    no_movement: "no movement",
    days: "days",
    edit_access: "Edit login details",
    leave_blank_keep: "Leave empty to keep the current password.",
    access_updated: "Login details updated",
    relogin_needed: "You changed your own password: please sign in again.",
    scan_qr_track: "Scan the QR to see the traceability",
    stalled_none: "No package has been at the hub for more than {d} days without leaving in a MASTER.",
    mixed: "Mixed",
    mixed_hint: "The office → warehouse leg can carry every transport type in the same vehicle: the warehouse receives and classifies them. Pick a specific type only if the exit must accept that type alone.",
    hub_direct: "Client drops the package straight at the HUB",
    hub_direct_hint: "It is registered, classified, verified and added to warehouse stock in a single step, with no office exit. It becomes available for a MASTER.",
  },
  ar: {
    dir: "rtl",
    app_name: "ميوس كارجو",
    app_tagline: "منصة شحن احترافية",
    login_title: "تسجيل الدخول",
    user_or_email: "اسم المستخدم أو البريد الإلكتروني",
    password: "كلمة المرور",
    enter: "دخول",
    demo_users: "مستخدمو تجريبي:",
    login_error: "اسم المستخدم أو كلمة المرور غير صحيحة",
    logout: "تسجيل الخروج",
    dashboard: "لوحة التحكم",
    quote_shipping: "احسب سعر الشحن",
    clients: "العملاء",
    shipments: "الشحنات",
    own_routes: "المسارات الخاصة",
    prices_margins: "الأسعار والهوامش",
    select_office: "اختر المكتب",
    main_office: "المكتب الرئيسي للبلد",
    exp_office_hint: "لن يظهر المصروف إلا في حسابات المكتب الذي تختاره.",
    orphans_title: "توجد سجلات محاسبية غير مرتبطة بأي مكتب",
    orphans_hint: "لا يراها أي فرع. حدّد مكتباً لتظهر في محاسبته.",
    orphans_adopt: "تعيينها لهذا المكتب",
    attach_receipt: "إرفاق الفاتورة / الإيصال",
    download_pdf: "تنزيل PDF",
    expense_voucher: "سند مصروف",
    payment_voucher: "سند قبض",
    provider_ranking: "ترتيب المصاريف حسب المورد",
    total_payable: "إجمالي المستحقات",
    overdue: "متأخرة",
    upcoming_dues: "استحقاقات قادمة",
    overdue_bills: "فواتير متأخرة",
    upcoming_bills: "فواتير قريبة الاستحقاق",
    attachment: "مرفق",
    attach_bill: "إرفاق الفاتورة / صورة",
    account_code: "رمز الحساب",
    search_users: "ابحث بالاسم أو رمز الحساب أو المعرف",
    main: "رئيسية",
    venc_vencida: "متأخرة",
    venc_proxima: "قريبة",
    venc_vigente: "سارية",
    venc_sin_vencimiento: "بدون تاريخ",
    inbound_master_actions: "هذه الشحنة متجهة إلى مكتبك",
    us_owe: "لهم علينا",
    we_owe: "علينا",
    last: "آخر",
    inbound_masters: "الشحنات الواردة",
    inbound_packages_hint: "طرد متجه إلى مكتبك",
    client_special_pricing: "أسعار خاصة للعملاء",
    client_special_pricing_hint: "تُطبّق هذه الأسعار تلقائياً عندما يقتبس العميل أو عندما يقتبس شخص ما نيابةً عنه.",
    volumetric_rules: "قواعد الحجم",
    users: "المستخدمون",
    api: "واجهة API",
    language: "اللغة",
    save: "حفظ",
    cancel: "إلغاء",
    new: "جديد",
    delete: "حذف",
    edit: "تعديل",
    active: "مفعّل",
    inactive: "غير مفعّل",
    actions: "إجراءات",
    status: "الحالة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    username: "اسم المستخدم",
    role: "الدور",
    admin: "المسؤول",
    ventas: "المبيعات",
    operaciones: "العمليات",
    cliente: "عميل",
    welcome: "مرحباً",
    quick_access: "وصول سريع",
    total_users: "المستخدمون",
    active_routes: "المسارات النشطة",
    air_divisor: "مقسم جوي",
    sea_divisor: "مقسم بحري",
    quote_type: "نوع النقل",
    aereo: "جوي",
    terrestre: "بري",
    maritimo: "بحري",
    origin_country: "بلد المنشأ",
    destination_country: "بلد الوجهة",
    select_option: "اختر...",
    china_city_origin: "مدينة المنشأ في الصين",
    china_notice: "لسوريا والعراق ولبنان، مسموح فقط من قوانغتشو أو ييوو",
    postal_origin: "الرمز البريدي للمنشأ (أوروبا)",
    postal_dest: "الرمز البريدي للوجهة (أوروبا)",
    cargo_type: "نوع البضاعة",
    cargo_kg: "كيلوغرام (KG)",
    cargo_cbm: "متر مكعب (CBM)",
    cargo_pallets: "طبالي",
    length: "الطول (سم)",
    width: "العرض (سم)",
    height: "الارتفاع (سم)",
    weight_kg: "الوزن (كجم)",
    cbm_amount: "كمية المتر المكعب",
    total_weight: "الوزن الكلي (كجم)",
    pallets_qty: "عدد الطبالي",
    hs_code: "رمز HS (اختياري)",
    calculate: "احسب الأسعار",
    select_route: "اختيار",
    empty_quote: "اختر المنشأ والوجهة ونوع النقل",
    empty_quote_sub: "يدعم الجوي والبري والبحري إلى كل العالم",
    meos_route: "★ مسار ميوس",
    estimated_rates: "أسعار تقديرية",
    origin: "المنشأ",
    destination: "الوجهة",
    price_base: "السعر الأساسي",
    price_kg: "السعر لكل كجم",
    price_cbm: "السعر لكل متر مكعب",
    price_pallet: "السعر لكل طبلية",
    transit_days: "أيام العبور",
    service_name: "اسم الخدمة",
    mode: "الوضع",
    all_modes: "جميع الأوضاع",
    new_route: "مسار جديد",
    edit_route: "تعديل المسار",
    routes_note: "المسارات الخاصة لها الأولوية على واجهات API الخارجية",
    fullname: "الاسم الكامل",
    new_user: "مستخدم جديد",
    user_created: "تم إنشاء المستخدم",
    user_exists: "المستخدم أو البريد الإلكتروني موجود بالفعل",
    general_margin: "الهامش العام (%)",
    guide_charge: "رسوم البوليصة ($)",
    air_divisor_full: "المقسم الجوي (معيار IATA = 6000)",
    sea_divisor_full: "المقسم البحري (معيار = 1000)",
    formula_air: "الصيغة: (طول × عرض × ارتفاع) / المقسم = كجم حجمي",
    formula_sea: "يستخدم لتحويل المتر المكعب إلى وزن تقديري",
    saved: "تم الحفظ بنجاح",
    deleted: "تم الحذف",
    confirm_delete: "تأكيد الحذف؟",
    no_clients: "لا يوجد عملاء مسجلون",
    shipments_soon: "وحدة الشحنات (قريباً)",
    tracking_code: "رمز التتبع",
    assign_client: "العميل المخصص",
    description: "الوصف / البضاعة",
    estimated_date: "التاريخ المتوقع",
    internal_notes: "ملاحظات داخلية",
    new_shipment: "شحنة جديدة",
    my_shipments: "شحناتي",
    my_registered_packages: "طرودي المسجلة",
    incoming_shipment: "وارد",
    backdate_label: "تاريخ سابق (المسؤول)",
    backdate_hint: "خيار المسؤول فقط — تسجيل الطرد بتاريخ ماضٍ",
    track: "تتبع",
    flow_clasificado: "مصنّف",
    flow_en_salida: "قيد المغادرة",
    flow_transito_hub: "في الطريق إلى المستودع",
    flow_recibido_hub: "استلم في المستودع",
    flow_verificado_hub: "تم التحقق",
    flow_en_master: "في الشحنة الرئيسية",
    flow_master_cerrado: "الشحنة الرئيسية مغلقة",
    flow_entregado: "تم التسليم",
    merch_charge_type: "نوع الرسوم",
    merch_per_shipment: "لكل شحنة",
    merch_per_kg: "لكل كيلوغرام",
    all_shipments: "كل الشحنات",
    sales_crm: "المبيعات · CRM",
    crm_quotes: "عروض الأسعار",
    crm_followups: "المتابعات",
    crm_new_lead: "عميل جديد",
    crm_no_leads: "لا يوجد عملاء مسجلون بعد",
    crm_no_history: "لا يوجد سجل بعد. سجّل أول اتصال",
    crm_log_call: "تسجيل اتصال",
    crm_new_quote: "عرض سعر",
    crm_add_task: "متابعة",
    crm_timeline: "السجل الشامل 360°",
    crm_no_results: "لا توجد نتائج",
    crm_leads_search_ph: "بحث بالاسم أو الهاتف أو البريد...",
    crm_call_when: "متى",
    crm_call_reason: "السبب",
    crm_caller: "من اتصل",
    crm_request: "ما الذي يحتاجه",
    crm_call_notes: "معلومات مهمة",
    crm_next_step: "المتابعة التالية",
    crm_action: "الإجراء",
    crm_when: "متى",
    crm_service: "الخدمة",
    crm_terms: "الشروط",
    crm_valid_until: "صالح حتى",
    crm_task_type: "النوع",
    crm_task_detail: "التفاصيل",
    crm_source: "المصدر",
    crm_company: "الشركة / العميل",
    crm_contact_person: "شخص الاتصال",
    crm_notes: "ملاحظات",
    crm_new_leads: "عملاء جدد (7 أيام)",
    crm_calls_today: "اتصالات اليوم",
    crm_quotes_pending: "عروض معلقة",
    crm_tasks_today: "متابعات اليوم",
    crm_tasks_overdue: "متأخرة",
    crm_tasks_upcoming: "الأسبوع القادم",
    crm_quotes_won: "مقبولة",
    crm_quotes_lost: "خاسرة",
    crm_no_tasks_today: "لا توجد متابعات مجدولة لهذا اليوم",
    crm_no_overdue: "لا توجد متأخرات. عمل رائع",
    crm_no_tasks: "لا توجد مهام في هذه المجموعة",
    crm_no_quotes: "لا توجد عروض أسعار",
    crm_seed_confirm: "تحميل 3 عملاء تجريبيين في CRM؟",
    crm_seed_hint_title: "لا توجد بيانات بعد",
    crm_seed_hint_desc: "قم بتحميل 3 عملاء تجريبيين مع الاتصالات وعروض الأسعار",
    crm_seed_btn: "تحميل أمثلة",
    crm_stats: "الإحصائيات",
    crm_route_data: "المسار المطلوب",
    crm_stats_total: "الاستفسارات",
    crm_stats_by_route: "الاستفسارات حسب المسار",
    crm_stats_empty: "لا توجد عروض أسعار بمعلومات مسار في النطاق المحدد",
    destination_city: "مدينة الوجهة",
    transport: "الوسيلة",
    from: "من",
    to: "إلى",
    crm_mark_done: "تحديد كمنجز",
    crm_state_nueva: "جديد",
    crm_state_cotizada: "بعرض السعر",
    crm_state_pendiente: "معلق",
    crm_state_seguimiento: "متابعة",
    crm_state_aceptada: "مقبول",
    crm_state_confirmada: "مؤكد",
    crm_state_rechazada: "مرفوض",
    crm_state_perdida: "خاسر",
    crm_state_cancelada: "ملغى",
    crm_type_llamar: "اتصال",
    crm_type_enviar_precio: "إرسال سعر",
    crm_type_enviar_docs: "إرسال مستندات",
    crm_type_esperar_confirmacion: "انتظار التأكيد",
    crm_type_confirmar_envio: "تأكيد الشحنة",
    crm_type_recontactar: "إعادة الاتصال",
    crm_type_otro: "آخر",
    crm_reason_cotizacion: "عرض سعر",
    crm_reason_seguimiento: "متابعة",
    crm_reason_complaint: "شكوى",
    crm_reason_reclamacion: "شكوى",
    crm_reason_informacion: "معلومات",
    crm_reason_info: "معلومات",
    crm_reason_quote: "عرض سعر",
    crm_reason_followup: "متابعة",
    crm_origin_call: "اتصال",
    crm_origin_web: "الويب",
    crm_origin_referral: "توصية",
    crm_origin_trade_show: "معرض",
    crm_origin_other: "آخر",
    crm_new_request: "إضافة طلب جديد",
    crm_request_contact: "بيانات الاتصال",
    crm_request_route: "مسار الشحنة",
    crm_request_cargo: "بيانات الحمولة",
    crm_contact_name: "اسم العميل",
    crm_from_country: "من (بلد الإرسال)",
    crm_to_country: "إلى (بلد الوصول)",
    crm_shipping_mode: "طريقة الشحن",
    trace_label_created: "تم إنشاء البطاقة",
    trace_received_warehouse: "استلم في المستودع",
    trace_grupaje_recibido_oficina: "استلم في المكتب",
    trace_grupaje_etiquetado: "تم وضع البطاقة",
    trace_grupaje_clasificado: "مصنّف",
    trace_grupaje_actualizado: "تم تحديث البيانات",
    trace_grupaje_anadido_salida: "أضيف إلى المغادرة",
    trace_grupaje_retirado_salida: "أزيل من المغادرة",
    trace_grupaje_salida_oficina: "مغادرة المكتب · في الطريق إلى المستودع",
    trace_grupaje_recibido_hub: "استلم في المستودع",
    trace_grupaje_verificado_hub: "تم التحقق في المستودع",
    trace_grupaje_faltante: "ناقص في الاستلام",
    trace_grupaje_anadido_master: "أضيف إلى الشحنة الرئيسية",
    trace_grupaje_retirado_master: "أزيل من الشحنة الرئيسية",
    trace_grupaje_master_cerrado: "الشحنة الرئيسية مغلقة",
    trace_grupaje_en_transito: "في الطريق إلى الوجهة",
    trace_grupaje_recibido_destino: "استلم في الوجهة",
    trace_grupaje_entregado: "تم التسليم",
    trace_inv_received: "استلم في المخزون",
    trace_inv_packaged: "تم التغليف",
    trace_inv_dispatched: "تم الإرسال",
    trace_picked_by_driver: "استلمها السائق",
    trace_in_dispatch_manifest: "في بيان المغادرة",
    trace_ship_status_recibido: "الحالة: استلم",
    trace_ship_status_despacho: "الحالة: تم الإرسال",
    trace_ship_status_en_aduana: "الحالة: في الجمارك",
    trace_ship_status_en_reparto: "الحالة: قيد التوصيل",
    trace_ship_status_entregado: "الحالة: تم التسليم",
    trace_audit_create_shipment: "تم إنشاء الشحنة",
    trace_audit_update_shipment: "تم تحديث الشحنة",
    trace_audit_delete_shipment: "تم حذف الشحنة",
    trace_audit_create_label: "تم إنشاء البطاقة",
    trace_audit_update_label: "تم تحديث البطاقة",
    trace_audit_delete_label: "تم حذف البطاقة",
    trace_audit_receive: "تم تسجيل الاستلام",
    trace_audit_dispatch: "تم تسجيل الإرسال",
    trace_audit_assign_master: "تم إسناد للشحنة الرئيسية",
    trace_audit_unassign_master: "تم الإزالة من الشحنة الرئيسية",
    trace_audit_create_manifest: "تم إنشاء البيان",
    trace_audit_close_manifest: "تم إغلاق البيان",
    trace_audit_scan: "تم تسجيل المسح",
    trace_audit_status_change: "تغيّرت الحالة",
    trace_audit_invoice: "تم إصدار الفاتورة",
    trace_audit_payment: "تم تسجيل الدفع",
    trace_audit_incident: "تم تسجيل الحادثة",
    state_received_office: "استلم في المكتب",
    state_labeled: "تم وضع البطاقة",
    state_added_master: "أضيف إلى الشحنة الرئيسية",
    state_added_office_exit: "أضيف إلى المغادرة",
    state_in_transit: "في الطريق إلى الوجهة",
    state_received_destination: "استلم في الوجهة",
    status_recibido: "تم الاستلام",
    status_despacho: "تم الإرسال",
    status_en_aduana: "في الجمرك",
    status_en_reparto: "خارج للتوصيل",
    status_entregado: "تم التسليم",
    update_status: "تحديث الحالة",
    status_history: "سجل الحالات",
    shipment_created: "تم إنشاء الشحنة",
    no_shipments: "ليس لديك شحنات بعد",
    no_shipments_admin: "لا توجد شحنات مسجلة",
    tracking_placeholder: "MEOS-2026-000123",
    client: "العميل",
    no_route_available: "لا يوجد مسار تم إعداده من قِبل المسؤول لهذه الوجهة",
    price_breakdown: "تفاصيل السعر",
    subtotal: "الإجمالي الجزئي",
    margin: "الهامش",
    guide_fee: "رسوم البوليصة",
    total: "الإجمالي",
    view_details: "عرض التفاصيل",
    base_prices_tiers: "الأسعار الأساسية والفئات",
    port_origin: "ميناء/مطار المنشأ",
    port_dest: "ميناء/مطار الوجهة",
    observations: "ملاحظات",
    fcl: "حاوية كاملة (FCL)",
    container_type: "نوع الحاوية",
    container_20: "20 قدم",
    container_40: "40 قدم",
    container_40hc: "40 HC",
    container_weight: "وزن الحاوية (كجم)",
    cargo_weight: "وزن البضاعة (كجم)",
    total_weight_fcl: "الوزن الإجمالي",
    price_20ft: "سعر 20 قدم ($)",
    price_40ft: "سعر 40 قدم ($)",
    price_40hc: "سعر 40HC ($)",
    public_tracking: "تتبع عام",
    track_placeholder: "أدخل رمز التتبع",
    track: "تتبع",
    notifications: "الإشعارات",
    no_notifications: "لا توجد إشعارات",
    mark_all_read: "وضع علامة مقروء للكل",
    currency: "العملة",
    sucursal: "فرع",
    office: "المكتب / الفرع",
    assigned_office: "المكتب المخصص",
    google_signin: "المتابعة مع Google",
    or: "أو",
    services_enabled: "الخدمات المفعّلة في هذا المسار",
    services_hint: "فقط الأنواع المحددة ستظهر عند التسعير.",
    price_kg_short: "كجم",
    pending: "قيد الانتظار",
    delivered_this_month: "تم التسليم هذا الشهر",
    recent_shipments: "أحدث الشحنات",
    notif_shipment_created_title: "شحنة جديدة {code}",
    notif_shipment_created_msg: "تم إنشاء شحنتك {origen} → {destino}",
    notif_status_change_title: "تحديث {code}",
    notif_status_change_msg: "شحنتك الآن: {status}",
    history: "السجل",
    quotes: "التسعيرات",
    no_history: "لا توجد تسعيرات بعد",
    search: "بحث...",
    province: "المحافظة / الولاية",
    sucursal_price: "سعر الفرع",
    sucursal_prices_hint: "سعر خاص يُطبَّق فقط لمستخدمي الفرع أو للعملاء الذين يُدخِلون هذه المحافظة.",
    ship_label: "بوليصة الشحن",
    print_label: "طباعة البوليصة",
    // CRM
    client_type: "نوع العميل",
    private: "شخصي",
    company: "شركة",
    address: "العنوان",
    city: "المدينة",
    country: "الدولة",
    postal_code: "الرمز البريدي",
    phone: "الهاتف",
    phone_alt: "هاتف بديل",
    rfc_nit: "الرقم الضريبي",
    doc_id: "وثيقة الهوية",
    sector: "القطاع / الصناعة",
    contact_person: "الشخص المسؤول",
    notes: "ملاحظات",
    assigned_branch: "الفرع المُخصَّص",
    auto_by_province: "تلقائي حسب المحافظة",
    edit_client: "تعديل العميل",
    new_client: "عميل جديد",
    search_clients: "ابحث بالاسم، البريد، الشركة أو الهاتف...",
    reset_password: "إعادة تعيين كلمة المرور",
    reset_password_manual: "تعيين كلمة مرور يدوياً",
    reset_password_email: "إرسال كلمة مرور مؤقتة عبر البريد",
    new_password: "كلمة مرور جديدة",
    password_reset_success: "تم تحديث كلمة المرور",
    password_sent_email: "تم إرسال كلمة المرور إلى",
    generated_password: "كلمة المرور المُنشأة",
    copy: "نسخ",
    copied: "تم النسخ",
    close: "إغلاق",
    personal_info: "المعلومات الشخصية",
    company_info: "معلومات الشركة",
    contact_info: "بيانات التواصل",
    address_info: "العنوان",
    complete_profile: "أكمل ملفك الشخصي",
    complete_profile_desc: "نحتاج بعض البيانات لتخصيص الفرع الصحيح لشحناتك.",
    skip_for_now: "لاحقاً",
    save_profile: "حفظ الملف",
    profile_updated: "تم تحديث الملف",
    provincias_covered: "المحافظات التي يغطيها هذا الفرع",
    provincias_hint: "أدخل المحافظات مفصولة بفواصل. سيتم تعيين الفرع تلقائياً للعملاء من هذه المحافظات.",
    registered_by: "سجَّله",
    self_registered: "تسجيل ذاتي",
    show_password: "إظهار",
    hide_password: "إخفاء",
    optional: "اختياري",
    // Shipment address fields
    sender: "المرسل",
    receiver: "المستلم",
    street: "الشارع",
    number: "رقم",
    tax_id: "الرقم الضريبي",
    address_reference: "مرجع العنوان",
    alias: "الاسم المستعار",
    save_address: "حفظ العنوان",
    address_book: "العناوين المحفوظة",
    load_from_book: "تحميل من العناوين",
    minimize: "تصغير",
    expand: "توسيع",
    // Warehouses / Inventory / Schedules / Countries
    countries: "الدول",
    new_country: "دولة جديدة",
    warehouses: "المستودعات",
    warehouse: "المستودع",
    new_warehouse: "مستودع جديد",
    no_warehouses: "لا توجد مستودعات",
    warehouse_required: "اختر مستودعاً",
    inventory: "المخزون",
    inbound: "دخول",
    outbound: "خروج",
    scan: "مسح",
    scan_barcode: "ماسح الباركود",
    scan_hint: "وجّه الماسح أو الصق الرمز واضغط Enter",
    scan_found: "تم العثور",
    not_found: "غير موجود",
    location: "الموقع",
    units: "الوحدات",
    state: "الحالة",
    state_received: "مُستلم",
    state_packaged: "مُغلَّف",
    state_dispatched: "مُرسَل",
    no_inventory: "لا توجد عناصر في المخزون",
    schedules: "الجدولة",
    admin_editable: "التعديل للمشرف فقط",
    read_only: "قراءة فقط",
    container: "الحاوية",
    route: "المسار",
    estimated_departure: "المغادرة المتوقعة",
    confirmed_departure: "المغادرة المؤكدة",
    estimated_arrival: "الوصول المتوقع",
    pending_approvals: "طلبات الموافقة",
    approve: "قبول",
    reject: "رفض",
    account_pending: "حسابك بانتظار الموافقة",
    account_pending_desc: "سيتم مراجعة تسجيلك قريباً من قبل المشرف وستصلك رسالة عبر البريد.",
    branch_pricing: "أسعار الفروع",
    add_branch_price: "إضافة سعر فرع",
    select_branch: "اختر الفرع",
    role_almacen: "مستودع",
    container_number: "رقم الحاوية",
    voyages: "الرحلات",
    voyage: "رحلة",
    new_voyage: "رحلة جديدة",
    no_voyages: "لا توجد رحلات",
    port_from: "ميناء المنشأ",
    port_to: "ميناء الوجهة",
    vessel: "السفينة / رقم السفينة",
    cut_off: "موعد الإغلاق",
    departure: "المغادرة",
    arrival: "الوصول",
    custom_fields: "حقول مخصصة",
    field_name: "اسم الحقل",
    value: "القيمة",
    add: "إضافة",
    air: "جوي",
    sea: "بحري",
    ground: "بري",
    vehicle: "المركبة",
    driver: "السائق",
    new_manifest: "بيان جديد",
    no_manifests: "لا توجد بيانات",
    manifest_sucursal_out: "خروج من الفرع",
    manifest_hub_in: "دخول للمركز",
    manifest_hub_out: "خروج من المركز",
    receive: "استلام",
    received: "تم الاستلام",
    receive_manifest: "استلام البيان",
    scan_manifest_barcode: "مسح باركود البيان",
    mark_missing: "تحديد طرد مفقود",
    missing: "مفقود",
    all_received_hint: "إذا لم تحدد شيئاً، سيتم استلام جميع الطرود",
    confirm_receipt: "تأكيد الاستلام",
    note_optional: "ملاحظة (اختياري)",
    select: "اختر",
    assign_shipments: "تعيين الشحنات",
    labels: "الملصقات",
    new_label: "ملصق جديد",
    no_labels: "لا توجد ملصقات",
    packages: "الطرود",
    dimensions: "الأبعاد",
    reference: "المرجع",
    content: "المحتوى",
    save_and_print: "إنشاء وطباعة",
    print: "طباعة",
    camera: "الكاميرا",
    camera_scan: "المسح بالكاميرا",
    stop: "إيقاف",
    manifests: "البيانات",
    // Scanner workflow
    scanner_mode: "وضع الماسح",
    mode_receive_manifest: "استلام مع بيان",
    mode_receive_direct: "استلام مباشر",
    mode_prepare_exit: "تجهيز الخروج",
    mode_receive_manifest_desc: "امسح البيان وتحقق من كل طرد",
    mode_receive_direct_desc: "استلم الطرود بدون بيان مسبق",
    mode_prepare_exit_desc: "امسح الطرود وأنشئ بيان الخروج تلقائياً",
    step_1_scan_manifest: "خطوة 1 · امسح البيان",
    step_2_scan_packages: "خطوة 2 · امسح كل طرد",
    step_3_close_reception: "خطوة 3 · إغلاق الاستلام",
    expected: "المتوقع",
    scanned: "الممسوح",
    matches: "المطابق",
    extras: "زائد",
    close_reception: "إغلاق الاستلام",
    open_reception: "بدء الاستلام",
    package_ok: "طرد صحيح",
    package_extra: "طرد زائد (غير متوقع)",
    package_duplicate: "تم مسحه مسبقاً",
    unknown_package: "طرد غير معروف",
    quick_create_shipment: "إنشاء شحنة سريعة",
    generate_exit_manifest: "إنشاء بيان خروج",
    exit_destination: "وجهة الخروج",
    scanned_packages: "الطرود الممسوحة",
    incidents: "الحوادث",
    incident_faltante: "مفقود",
    incident_extra: "زائد",
    incident_dano: "تلف",
    incident_retraso: "تأخير",
    severity: "الخطورة",
    severity_low: "منخفض",
    severity_medium: "متوسط",
    severity_high: "مرتفع",
    audit_trail: "سجل التدقيق الداخلي",
    public_tracking: "التتبع العام",
    reception_summary: "ملخص الاستلام",
    of: "من",
    remove: "إزالة",
    reset: "إعادة",
    photo_url: "رابط الصورة (اختياري)",
    warehouse_id_required: "المستودع مطلوب",
    client_required_new_pkg: "اختر عميلاً لإنشاء الشحنة",
    incidents_created: "الحوادث المنشأة",
    view_audit: "عرض التدقيق",
    action: "الإجراء",
    when: "متى",
    who: "من",
    reception_started: "بدأ الاستلام",
    reception_closed: "أُغلق الاستلام",
    // Albaranes / Locations / voyage detail extra keys
    package_receipt: "إشعار التسليم",
    new_delivery_note: "إشعار جديد",
    no_delivery_notes: "لا توجد إشعارات",
    incidence_optional: "حادثة (اختياري)",
    save_and_pdf: "حفظ + PDF",
    package_weight_kg: "الوزن كغ",
    packages_count: "الطرود",
    receiver_name: "اسم المستلم",
    address: "العنوان",
    country: "الدولة",
    city: "المدينة",
    pickup: "الاستلام",
    delivery: "التسليم",
    receiver: "المستلم",
    shipment: "الشحنة",
    tracking: "التتبع",
    global_audit: "التدقيق العام",
    zone_required: "المنطقة *",
    aisle_required: "الممر *",
    warehouse_required: "المستودع *",
    rack_short: "رف",
    level: "مستوى",
    position_short: "موضع",
    cap_units: "سعة",
    new_location: "موقع جديد",
    no_locations_add_first: "لا توجد مواقع. أضف الأول.",
    all_warehouses: "كل المستودعات",
    create: "إنشاء",
    auto_prefix: "تلقائي",
    signature_receiver: "توقيع المستلم",
    clear: "مسح",
    courier: "بريد سريع",
    courier_documentos: "وثائق",
    courier_pasaporte: "جواز سفر",
    courier_goods: "بضائع",
    locations: "مواقع المستودع",
    zone: "المنطقة",
    type: "النوع",
    date_col: "التاريخ",
    route_col: "المسار",
    mode_col: "الوسيلة",
    cargo_col: "الحمولة",
    best_price_col: "أفضل سعر",
    delivery_receipts: "إيصالات التسليم",
    // Merchandise
    merchandise: "البضاعة",
    merchandise_types: "أنواع البضاعة",
    merchandise_types_hint: "فئات قابلة للتخصيص لكل مسار برسوم اختيارية وعلم إلزامي",
    add_merchandise_type: "إضافة نوع",
    no_merchandise_types: "لا توجد أنواع بضاعة",
    merch_name: "الاسم",
    merch_name_ph: "إلكترونيات، ملابس، قابل للكسر...",
    merch_surcharge: "رسوم إضافية",
    mandatory: "إلزامي",
    merch_required_hint: "اختر نوع البضاعة للمتابعة",
    // Assign to voyage
    assign_to_voyage: "تعيين إلى الرحلة",
    select_for_dispatch: "تحديد للإرسال",
    select_shipments_hint: "اختر شحنة واحدة على الأقل",
    selected_shipments: "الشحنات المحددة",
    manifest_will_be_generated: "سيتم إنشاء بيان الشحن",
    no_voyage_optional: "بدون رحلة (اختياري)",
    manifest_name: "اسم البيان",
    manifest_copy: "نسخة البيان",
    assign_and_generate: "تعيين وإنشاء",
    assigned: "تم التعيين",
    not_found: "غير موجود",
    dispatch: "الإرسال",
    departure: "المغادرة",
    vehicle: "المركبة",
    driver: "السائق",
    container: "الحاوية",
    // Multi-box
    boxes: "الصناديق",
    bultos: "قطع",
    bultos_short: "قطعة",
    add_box: "إضافة صندوق",
    boxes_editor_hint: "قسّم الشحنة إلى عدة صناديق برمز ووزن مستقلين",
    no_items_single_box: "لا توجد صناديق: سيتم إنشاؤها كشحنة بصندوق واحد",
    print_all_labels: "جميع البطاقات",
    report_language: "لغة التقرير",
    role_contable: "محاسب",
    contable: "محاسب",
    all: "الكل",
    date: "التاريخ",
    wms_locations: "مواقع المستودع",
    albaranes: "سندات التسليم",
    fleet: "الأسطول والسائقون",
    drivers: "السائقون",
    vehicles: "المركبات",
    driver_routes: "خطوط التوزيع",
    new_driver: "سائق جديد",
    new_vehicle: "مركبة جديدة",
    new_driver_route: "خط توزيع جديد",
    no_routes_yet: "لا توجد خطوط توزيع بعد",
    no_vehicle: "بدون مركبة",
    stops: "المحطات",
    plate: "رقم اللوحة",
    brand: "الماركة",
    model: "الطراز",
    capacity_kg: "الحمولة (كغ)",
    capacity_m3: "الحمولة (م³)",
    insurance: "التأمين",
    license: "رخصة القيادة",
    license_expiry: "انتهاء الرخصة",
    expiry_alert: "قارب الانتهاء",
    veh_furgoneta: "شاحنة صغيرة",
    veh_camion: "شاحنة",
    veh_trailer: "مقطورة",
    veh_coche: "سيارة",
    route_state_pendiente: "معلّق",
    route_state_en_curso: "قيد التنفيذ",
    route_state_completada: "مكتمل",
    stop_pendiente: "معلّق",
    stop_en_camino: "في الطريق",
    stop_entregado: "تم التسليم",
    stop_fallido: "فشل",
    stop_type_entrega: "تسليم",
    stop_type_recogida: "استلام",
    conductor: "سائق",
    role_conductor: "سائق",
    link_user_account: "حساب المستخدم (لتطبيق السائق)",
    edit_driver: "تعديل السائق",
    edit_vehicle: "تعديل المركبة",
    my_route: "خط سيري",
    no_route_today: "لا يوجد خط سير مُعيَّن لك",
    mark_on_the_way: "في الطريق",
    mark_delivered: "تم التسليم + الإيصال",
    mark_picked_up: "تم الاستلام + الإيصال",
    mark_failed: "فشل التسليم",
    delivery_evidence: "صور الإثبات (الهوية، البضاعة)",
    print_receipt: "إيصال PDF",
    open_maps: "الخريطة",
    call: "اتصال",
    whatsapp_notify: "إشعار عبر واتساب",
    optimize_route: "تحسين المسار",
    optimizing: "جارٍ التحسين…",
    route_optimized: "تم ترتيب المسار حسب القرب",
    total_distance: "المسافة الإجمالية",
    est_arrival: "الوصول المتوقع",
    stops_no_location: "محطات بدون موقع",
    search_shipment: "ابحث بالرمز أو العميل أو المنشأ أو الوجهة…",
    no_search_results: "لا توجد نتائج لبحثك",
    whatsapp_auto: "واتساب تلقائي",
    whatsapp_auto_hint: "إشعار العميل عبر واتساب عند كل تغيير للحالة",
    transport_mode: "النقل",
    road: "بري",
    account_number: "رقم الحساب",
    auto_account: "تلقائي",
    download_backup_pc: "تنزيل النسخة الاحتياطية إلى جهازي",
    email_backup_now: "إرسال النسخة الاحتياطية بالبريد الآن",
    backup_email_sent: "تم إرسال النسخة الاحتياطية بالبريد",
    pickup_scan: "الاستلام بالمسح",
    pickup_scan_hint: "امسح الشحنات أو الصناديق أو الملصقات وأنشئ بيان استلام",
    scan_or_type_code: "امسح أو اكتب الرمز…",
    generate_pickup_manifest: "إنشاء بيان الاستلام",
    picked_up: "تم الاستلام",
    scan_at_least_one: "أضف رمزًا واحدًا على الأقل",
    give_entry: "إدخال",
    already_received: "تم استلام هذا الملصق مسبقًا",
    recipient: "المستلم",
    label: "ملصق",
    trace: "التتبع",
    trace_search: "ابحث بالتتبع أو الملصق أو رمز الصندوق…",
    trace_timeline: "السجل الداخلي للطرد",
    trace_no_result: "لا نتائج لهذا الرمز",
    pickups_tab: "الاستلامات",
    pickups_today: "استلامات اليوم",
    total_weight: "الوزن الإجمالي",
    notify_pickup_wa: "إشعار الاستلام عبر واتساب",
    website: "الموقع الإلكتروني",
    bank: "البنك",
    concept: "البيان",
    charges: "المدين",
    credits: "الدائن",
    paid: "المدفوع",
    remarks: "ملاحظات",
    remarks_hint: "اتركه فارغاً لاستخدام النص الافتراضي للفرع أو الشركة",
    edit_invoice: "تعديل الفاتورة",
    acc_tab_aging: "المتأخرات",
    acc_tab_suppliers: "الموردون",
    acc_tab_branches: "الفروع",
    acc_tab_statement: "كشوف الحساب",
    receivables: "مستحقات على العملاء",
    payables: "مستحقات للموردين",
    outstanding_total: "إجمالي المستحق",
    overdue_total: "إجمالي المتأخر",
    days_overdue: "أيام التأخير",
    nothing_overdue: "لا توجد أرصدة مستحقة",
    bucket_no_vencido: "غير مستحق",
    bucket_d0_30: "١-٣٠ يوم",
    bucket_d31_60: "٣١-٦٠ يوم",
    bucket_d61_90: "٦١-٩٠ يوم",
    bucket_d90_plus: "أكثر من ٩٠ يوم",
    bucket_sin_vencimiento: "بدون تاريخ استحقاق",
    suppliers: "الموردون",
    supplier: "المورّد",
    new_supplier: "مورّد جديد",
    purchase_invoices: "فواتير الشراء",
    purchase_invoice: "فاتورة شراء",
    new_bill: "فاتورة شراء جديدة",
    bill_number: "رقم المورّد",
    new_bill_payment: "تسجيل دفعة",
    owed_to_suppliers: "المستحق للموردين",
    owed_by_branches: "المستحق على الفروع",
    branch_account: "الحساب الجاري للفروع",
    ledger_entries: "قيود مدين ودائن",
    new_ledger_entry: "قيد مدين / دائن جديد",
    ledger_hint: "مدين = الفرع مدين لنا · دائن = الفرع سدّد",
    mov_cargo: "مدين",
    mov_abono: "دائن",
    mov_factura: "فاتورة",
    mov_cobro: "تحصيل",
    mov_gasto: "مصروف",
    mov_factura_compra: "فاتورة شراء",
    mov_pago: "دفعة",
    statement: "كشف حساب",
    statement_type: "نوع الكشف",
    statement_of_general: "عام",
    statement_of_cliente: "العميل",
    statement_of_proveedor: "المورّد",
    statement_of_oficina: "الفرع",
    opening_balance: "الرصيد الافتتاحي",
    closing_balance: "الرصيد الختامي",
    total_charges: "إجمالي المدين",
    total_credits: "إجمالي الدائن",
    movement: "الحركة",
    charge: "مدين",
    credit: "دائن",
    no_movements: "لا توجد حركات في هذه الفترة",
    pick_statement_entity: "اختر النوع والجهة لعرض كشف الحساب",
    invoice_settings: "إعدادات الفواتير",
    invoice_settings_hint: "البيانات والتنسيق الذي يظهر في كل فواتيرك وكشوفك",
    company_data: "بيانات الشركة",
    invoice_style: "تنسيق الفاتورة",
    brand_color: "لون العلامة",
    show_logo: "إظهار الشعار",
    logo_size: "حجم الشعار (pt)",
    show_iban: "إظهار البيانات المصرفية",
    footer_text: "نص التذييل",
    default_remarks: "الملاحظات الافتراضية",
    save_settings: "حفظ الإعدادات",
    settings_saved: "تم حفظ الإعدادات",
    legal_name: "الاسم القانوني",
    prefix: "البادئة",
    branch_profiles: "البيانات الضريبية لكل فرع",
    branch_profiles_hint: "أنت فقط كمدير تحدد ما يظهر في فواتير كل فرع",
    new_branch_profile: "فرع جديد",
    my_invoices: "فواتيري",
    my_invoices_hint: "فواتيرك ورصيدك وكشف حسابك",
    no_invoices_yet: "لا توجد فواتير بعد",
    download_statement: "تنزيل كشف الحساب",
    linked_shipment: "الشحنة المرتبطة",
    surcharge_fixed: "رسم ثابت",
    surcharge_unit: "رسم/وحدة",
    extra_days: "أيام إضافية",
    surcharge_hint: "الرسم لكل وحدة يُضرب في الكيلوغرامات أو الأمتار المكعبة أو المنصات المسعّرة",
    province_surcharge: "رسم المحافظة",
    package_code: "رمز الصندوق",
    package_notes: "الملاحظات",
    add_note_placeholder: "اكتب ملاحظة...",
    note_public: "مرئية للعميل",
    no_notes: "لا توجد ملاحظات",
    state_label_created: "تم إنشاء البطاقة",
    state_received_warehouse: "تم الاستلام في المستودع",
    locations: "مواقع المستودع",
    zone: "المنطقة",
    loc_type_storage: "تخزين",
    loc_type_receiving: "استلام",
    loc_type_dispatch: "إرسال",
    loc_type_quarantine: "حجر",
    loc_type_damage: "تالف",
    loc_type_cross_dock: "عبور",
    loc_type_pending: "معلّق",
    reception_date: "تاريخ الاستلام",
    label_received: "تم استلام البطاقة في المستودع",
    departure_date: "تاريخ المغادرة",
    packages_in_master: "صناديق هذه الشحنة",
    subject: "الموضوع",
    email_notifications: "إشعارات البريد الإلكتروني",
    email_sender: "المرسل",
    email_domain_ok: "النطاق موثّق",
    email_domain_pending: "النطاق غير موثّق",
    email_why_failing: "لماذا لا تصل رسائل البريد إلى العملاء",
    email_fix_steps: "يسمح Resend بالإرسال إلى بريدك فقط حتى توثّق نطاقاً. ادخل إلى resend.com/domains ووثّق نطاقك (مثل meoscargo.com) ثم غيّر SENDER_EMAIL إلى بريد مثل no-reply@meoscargo.com. بعد ذلك ستصل الرسائل إلى أي عميل.",
    email_open_diagnostics: "فتح التشخيص",
    email_sender: "المرسل",
    email_send_test: "إرسال تجربة",
    email_test_placeholder: "correo@destino.com",
    email_test_ok: "تم إرسال البريد",
    email_test_fail: "فشل الإرسال",
    email_sent: "أُرسل",
    email_failed: "فشل",
    email_requested: "طُلب",
    email_delivered: "سُلّم",
    email_bounced: "ارتدّ",
    email_errors: "أخطاء",
    email_resend: "إعادة الإرسال",
    email_resent: "تم إعادة إرسال البريد",
    optional: "اختياري",
    dest_province: "محافظة الوصول",
    dest_provinces: "محافظات الوصول المتوفرة",
    dest_provinces_hint: "أضف المحافظات/المدن التي تخدمها على هذا الخط. حدّد المربع لإلزام العميل باختيار واحدة.",
    no_dest_provinces: "بدون محافظات: يمكن للعميل كتابتها بحرية",
    add_province: "إضافة محافظة",
    province_mandatory: "إلزامية للعميل",
    province_optional_hint: "اختياري · يفعّل سعر الفرع",
    boxes_from_labels_hint: "أنشئ البطاقات أولاً ثم أضفها هنا كصناديق للشحنة الرئيسية",
    labels_flow_hint: "التدفق: ١) أنشئ البطاقة واطبعها · ٢) أضفها كصندوق في شحنة رئيسية · ٣) عيّن الشحنة الرئيسية إلى بيان/رحلة",
    add_from_labels: "إضافة من البطاقات",
    add_selected: "إضافة المحددة",
    no_available_labels: "لا توجد بطاقات متاحة. أنشئها في قسم البطاقات.",
    label_available: "متاحة",
    label_used: "مستخدمة",
    used_in: "مستخدمة في",
    manual_code: "رمز يدوي",
    search_code: "ابحث برمز أو عميل أو محتوى...",
    box_code: "رمز الصندوق",
    accounting: "المحاسبة",
    acc_tab_summary: "ملخص",
    acc_tab_expenses: "المصروفات",
    acc_tab_invoices: "الفواتير",
    acc_tab_payments: "التحصيلات",
    acc_scope_global: "عرض شامل لجميع الفروع",
    acc_scope_branch: "يمكنك فقط إضافة المصروفات وإنشاء الفواتير وتسجيل التحصيلات",
    new_expense: "مصروف جديد",
    new_invoice: "فاتورة جديدة",
    new_payment: "تحصيل جديد",
    invoiced: "إجمالي الفواتير",
    collected: "المحصّل",
    available: "المتاح",
    pending_collection: "المستحق",
    total_expenses: "المصروفات",
    profit: "الربح",
    expenses: "مصروفات",
    invoices: "فواتير",
    payments: "تحصيلات",
    bucket_current: "جارية",
    bucket_1_30: "1-30 يوم",
    bucket_31_60: "31-60 يوم",
    bucket_61_90: "61-90 يوم",
    bucket_90_plus: "+90 يوم",
    statement_of_client: "كشف حساب العميل",
    statement_of_supplier: "كشف حساب المورّد",
    category: "الفئة",
    supplier: "المورّد",
    amount: "المبلغ",
    vat: "الضريبة %",
    payment_method: "طريقة الدفع",
    invoice: "فاتورة",
    invoice_number: "رقم الفاتورة",
    due_date: "تاريخ الاستحقاق",
    invoice_lines: "بنود الفاتورة",
    qty: "الكمية",
    unit_price: "سعر الوحدة",
    balance: "الرصيد",
    by_office: "حسب الفرع",
    by_category: "حسب الفئة",
    from_date: "من",
    to_date: "إلى",
    all_offices: "كل الفروع",
    office: "الفرع",
    who: "بواسطة",
    inv_status_pendiente: "معلّقة",
    inv_status_parcial: "جزئية",
    inv_status_pagada: "مدفوعة",
    exp_cat_combustible: "وقود",
    exp_cat_alquiler: "إيجار",
    exp_cat_salarios: "رواتب",
    exp_cat_aduanas: "جمارك",
    exp_cat_transporte: "نقل",
    exp_cat_suministros: "لوازم",
    exp_cat_otros: "أخرى",
    pay_transferencia: "حوالة بنكية",
    pay_efectivo: "نقداً",
    pay_tarjeta: "بطاقة",
    pay_bizum: "بيزوم",
    pay_cheque: "شيك",
    pay_credito: "آجل",
    discount: "خصم",
    switch_to_percent: "تبديل إلى نسبة مئوية",
    switch_to_amount: "تبديل إلى مبلغ ثابت",
    use_default_remarks: "استخدام الافتراضي",
    notes_placeholder: "أضف أي معلومات إضافية تظهر على الفاتورة…",
    backups: "النسخ الاحتياطية",
    run_backup: "إنشاء نسخة الآن",
    backup_done: "تم إنشاء النسخة",
    no_backups: "لا توجد نسخ احتياطية بعد",
    backup_schedule: "الجدولة",
    backup_schedule_value: "تلقائياً كل يوم الساعة 03:00 UTC",
    backup_where: "مكان التخزين",
    backup_where_value: "Emergent Object Storage · meoscargo/backup/YYYYMMDD/",
    backup_restore: "الاستعادة",
    size: "الحجم",
    file: "الملف",
    download: "تنزيل",
    refresh: "تحديث",
    new_package: "شحنة جديدة",
    package: "شحنة",
    packages_flow_hint: "استلام بالمكتب → ملصق → تصنيف → مغادرة المكتب → تحقق بالمستودع → ماستر → البيان",
    carrier: "الناقل",
    carrier_tracking: "تتبع الناقل",
    internal_tracking: "التتبع الداخلي",
    service_type: "نوع الخدمة",
    origin_city: "مدينة المنشأ",
    dest_country: "بلد الوصول",
    dest_city: "مدينة الوصول",
    length_cm: "الطول (سم)",
    width_cm: "العرض (سم)",
    height_cm: "الارتفاع (سم)",
    declared: "المعلن",
    received_val: "المستلم",
    flow_state: "حالة المسار",
    express: "إكسبريس",
    reception_office: "مكتب الاستلام",
    auto_cbm_hint: "يُحسب الحجم تلقائياً من الأبعاد",
    office_exits: "مغادرات المكتب",
    new_office_exit: "مغادرة جديدة",
    office_exit: "مغادرة المكتب",
    hub_destination: "المستودع المقصود",
    add_packages: "إضافة شحنات",
    scan_or_type: "امسح أو اكتب الرمز",
    close_exit: "إغلاق المغادرة والإرسال للمستودع",
    hub_reception: "الاستلام في المستودع",
    start_reception: "بدء الاستلام",
    reception_ok: "الاستلام سليم",
    reception_incidents: "استلام مع ملاحظات",
    expected_totals: "المتوقع",
    received_totals: "المستلم",
    physical_state: "الحالة المادية",
    damaged: "تالف",
    state_ok: "سليم",
    scan_package: "مسح الشحنة",
    pending_scan: "في انتظار المسح",
    verified: "تم التحقق",
    masters: "الماستر",
    new_master: "ماستر جديد",
    master: "ماستر",
    transport_ref: "رحلة / سفينة / شاحنة",
    etd: "موعد المغادرة",
    eta: "موعد الوصول",
    close_master: "إغلاق الماستر",
    master_manifest: "بيان الماستر",
    add_to_master: "إضافة إلى الماستر",
    added_ok: "أُضيفت",
    rejected_items: "مرفوضة",
    force_admin: "تصريح خاص (المدير فقط)",
    total_packages: "إجمالي الشحنات",
    total_units: "إجمالي الوحدات",
    total_cbm: "الحجم الإجمالي",
    exit_abierta: "مفتوحة",
    exit_en_recepcion: "قيد الاستلام",
    exit_en_transito: "في الطريق للمستودع",
    exit_recibida_hub: "مستلمة بالمستودع",
    exit_recibida_con_incidencias: "مستلمة مع ملاحظات",
    master_abierto: "مفتوح",
    master_cerrado: "مغلق",
    master_en_transito: "في الطريق",
    master_recibido_destino: "مستلم في الوجهة",
    master_entregado: "تم التسليم",
    fs_recibido_oficina: "مستلم بالمكتب",
    fs_etiquetado: "تم وضع الملصق",
    fs_clasificado: "مصنف",
    fs_en_salida: "في مغادرة المكتب",
    fs_transito_hub: "في الطريق للمستودع",
    fs_recibido_hub: "مستلم بالمستودع",
    fs_verificado_hub: "تم التحقق بالمستودع",
    fs_en_master: "في الماستر",
    fs_master_cerrado: "الماستر مغلق",
    fs_en_transito: "في الطريق",
    fs_recibido_destino: "مستلم في الوجهة",
    fs_entregado: "تم التسليم",
    inc_diferencia_peso: "فرق في الوزن",
    inc_diferencia_unidades: "فرق في الوحدات",
    inc_diferencia_dimensiones: "فرق في الأبعاد",
    inc_diferencia_cbm: "فرق في الحجم",
    inc_etiqueta_incorrecta: "ملصق غير صحيح",
    inc_tracking_incorrecto: "تتبع غير صحيح",
    inc_destino_incorrecto: "وجهة غير صحيحة",
    inc_transporte_incorrecto: "نوع نقل غير صحيح",
    inc_documentacion: "مشكلة في المستندات",
    inc_otra: "ملاحظة أخرى",
    currencies: "العملات",
    exchange_rates: "أسعار الصرف",
    base_currency: "العملة الأساسية",
    totals_by_currency: "الإجماليات حسب العملة",
    converted_total: "الإجمالي المحوّل",
    save_rates: "حفظ أسعار الصرف",
    rate_hint: "قيمة وحدة واحدة بالعملة الأساسية",
    timeline: "التتبع",
    grupaje_flow: "مسار التجميع",
    open_detail: "عرض التفاصيل",
    no_office_exits: "لا توجد مغادرات بعد",
    no_masters: "لا يوجد ماستر بعد",
    no_packages: "لا توجد شحنات بعد",
    legacy: "السجل السابق",
    legacy_notice: "شاشة سابقة (قبل مسار التجميع). المسار الحالي: 1 الشحنات → 2 مغادرات المكتب → 3 الاستلام في المستودع → 4 الماستر (مع بيانه) → 5 التتبع.",
    master_hint: "الماستر يجمع الشحنات المتحققة التي تسافر معاً (رحلة أو سفينة أو شاحنة). البيان (MANIFEST) هو مستند PDF للماستر يحتوي قائمة الشحنات والإجماليات ويُصدر من الماستر نفسه.",
    stalled_alert: "{n} شحنة موجودة في المستودع لأكثر من {d} أيام دون المغادرة في أي ماستر.",
    view_only_stalled: "إظهار المتوقفة فقط",
    no_movement: "بدون حركة",
    days: "أيام",
    edit_access: "تعديل بيانات الدخول",
    leave_blank_keep: "اتركه فارغاً للإبقاء على كلمة المرور الحالية.",
    access_updated: "تم تحديث بيانات الدخول",
    relogin_needed: "لقد غيّرت كلمة مرورك: يرجى تسجيل الدخول مرة أخرى.",
    scan_qr_track: "امسح رمز QR لعرض التتبع",
    stalled_none: "لا توجد شحنة في المستودع لأكثر من {d} أيام دون المغادرة في ماستر.",
    mixed: "مختلط",
    mixed_hint: "يمكن لمسار المكتب → المستودع أن يحمل جميع أنواع النقل في نفس المركبة: المستودع يستلمها ويصنفها. اختر نوعاً محدداً فقط إذا أردت أن تقبل المغادرة هذا النوع وحده.",
    hub_direct: "العميل يسلّم الشحنة مباشرة في المستودع",
    hub_direct_hint: "يتم تسجيلها وتصنيفها والتحقق منها وإدخالها إلى مخزون المستودع في خطوة واحدة، بدون مغادرة مكتب، وتصبح متاحة لإضافتها إلى ماستر.",
  },
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("meos_lang") || "es");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = translations[lang].dir;
    localStorage.setItem("meos_lang", lang);
  }, [lang]);

  const t = useCallback((key) => translations[lang][key] || key, [lang]);

  // Stable context value prevents every consumer from re-rendering on unrelated parent updates
  const value = useMemo(
    () => ({ lang, setLang, t, dir: translations[lang].dir }),
    [lang, t]
  );

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
